import * as React from 'react';

import { createIllustration } from './Illustration';

function describeWithOptions(name: string, description: string) {
  return {
    name,
    description,
    height: 200,
    width: 200,
  };
}

// ------------------------------
// Begin
// ------------------------------

export const MediumBegin = createIllustration(
  describeWithOptions(
    'MediumBegin',
    'Illustration of a woman sitting in an office, holding her phone. Above the woman are stylised line-items with dollar signs beside them.'
  ),
  <React.Fragment>
    <path
      d="M176.069 40.264c13.668 17.326 8.237 48.738-2.518 72.692-10.817 23.909-26.975 40.406-47.931 51.987-20.955 11.581-46.663 18.339-66.171 10.135-19.509-8.204-32.724-31.28-39.15-56.461-6.428-25.226-5.978-52.514 7.92-69.933 13.899-17.418 41.22-24.918 71.332-27.022 30.043-2.05 62.855 1.226 76.518 18.602z"
      fill="#f2f3f4"
    />
    <g clipRule="evenodd" fillRule="evenodd">
      <path d="M151.111 54.149h16.195l2.188-21.936h-16.196z" fill="#dceeff" />
      <path
        d="M150.832 30.465h19.697l-2.535 25.432h-19.698zm3.153 3.496l-1.838 18.44h12.694l1.838-18.44z"
        fill="#c3e4ff"
      />
      <path d="M150.237 54.149h16.497l2.187-21.936h-16.497z" fill="#fff" />
      <path
        d="M152.109 31.863h17.197L167.049 54.5h-17.197l2.257-22.636zm.63.7l-2.117 21.236h15.796l2.118-21.237h-15.797z"
        fill="#c3e4ff"
      />
      <path d="M153.397 51.252h10.755l1.609-16.143h-10.755z" fill="#e8f6ff" />
      <path
        d="M193.884 38.737l-1.516 15.198h-19.901l1.516-15.198z"
        fill="#dceeff"
      />
      <path
        d="M171.709 36.989h23.403l-1.865 18.694h-23.402zm3.153 3.496l-1.167 11.702h16.399l1.167-11.702z"
        fill="#c3e4ff"
      />
      <path
        d="M193.438 38.737l-1.515 15.198h-20.272l1.516-15.198z"
        fill="#fff"
      />
      <path
        d="M172.852 38.387h20.972l-1.586 15.898h-20.972zm.631.7l-1.446 14.498h19.57l1.446-14.498z"
        fill="#c3e4ff"
      />
      <path
        d="M189.164 41.718l-.921 9.235h-12.317l.921-9.235z"
        fill="#e8f6ff"
      />
      <path
        d="M126.608 48.255c0 1.163.94 2.106 2.099 2.106h18.878v-4.213h-18.878a2.103 2.103 0 00-2.099 2.106z"
        fill="#c3e4ff"
      />
      <path
        d="M139.306 48.255c0 .673.543 1.22 1.214 1.22h7.014a.05.05 0 00.051-.052v-2.337a.05.05 0 00-.051-.051h-7.014c-.671 0-1.214.546-1.214 1.22z"
        fill="#e8f6ff"
      />
      <path
        d="M123.974 50.361v4.214h20.605a2.102 2.102 0 002.098-2.107 2.102 2.102 0 00-2.098-2.107z"
        fill="#aad5ff"
      />
      <path
        d="M123.974 51.26v2.416h8.472c.664 0 1.203-.541 1.203-1.208s-.539-1.208-1.203-1.208z"
        fill="#e8f6ff"
      />
      <path d="M117.284 57.373h71.031v-2.995h-71.031z" fill="#c3e4ff" />
      <path
        d="M188.315 57.373H200v-2.995h-11.685zm-53.719 0l5.547 8.738v-8.738z"
        fill="#aad5ff"
      />
      <path
        d="M131.527 57.373l5.547 8.738h3.069l-5.547-8.738z"
        fill="#c3e4ff"
      />
      <path d="M175.279 57.373l5.547 8.738v-8.738z" fill="#aad5ff" />
      <path d="M172.21 57.373l5.547 8.738h3.069l-5.547-8.738z" fill="#c3e4ff" />
    </g>
    <path
      d="M100.579 31.976H12a1.75 1.75 0 01-1.75-1.75V11c0-.966.784-1.75 1.75-1.75h88.579c.967 0 1.75.784 1.75 1.75v19.226a1.75 1.75 0 01-1.75 1.75z"
      fill="#fff"
      stroke="#e4e5e6"
      strokeWidth={0.5}
    />
    <path
      d="M23.501 13.516c3.914 0 7.072 3.178 7.072 7.1s-3.158 7.094-7.072 7.094-7.072-3.172-7.072-7.094 3.159-7.1 7.072-7.1zm-.393 2.568v.634a2.133 2.133 0 00-1.242.769c-.35.44-.528.928-.528 1.355 0 .624.32 1.125.694 1.472.651.604 1.573.742 2.25 1.213.366.26.595.553.595.861 0 .164-.117.563-.357.862-.239.3-.56.517-1.02.517-.295 0-.621-.119-.884-.301-.263-.183-.45-.433-.51-.616a.41.41 0 00-.5-.25.412.412 0 00-.25.502c.135.408.44.75.817 1.01.274.19.592.34.934.407v.628h.786v-.634a2.133 2.133 0 001.242-.77c.35-.439.528-.927.528-1.354 0-.677-.46-1.177-.928-1.51-.666-.505-1.59-.615-2.175-1.145-.265-.245-.437-.531-.437-.892 0-.164.118-.563.357-.862.239-.3.56-.517 1.02-.517.295 0 .622.113.884.296.263.182.45.432.51.615a.41.41 0 00.501.25.412.412 0 00.25-.502c-.136-.408-.441-.749-.818-1.01a2.448 2.448 0 00-.934-.4v-.628z"
      fill="#fc1c88"
    />
    <path
      d="M35.717 14.806h57.862v3.871H35.717zm0 7.984h57.862v3.871H35.717z"
      fill="#e4e7ea"
    />
    <path
      d="M100.579 60.363H12a1.75 1.75 0 01-1.75-1.75V39.387c0-.966.784-1.75 1.75-1.75h88.579c.967 0 1.75.784 1.75 1.75v19.226a1.75 1.75 0 01-1.75 1.75z"
      fill="#fff"
      stroke="#e4e5e6"
      strokeWidth={0.5}
    />
    <path
      d="M23.501 41.903c3.914 0 7.072 3.178 7.072 7.1s-3.158 7.094-7.072 7.094-7.072-3.172-7.072-7.094 3.159-7.1 7.072-7.1zm-.393 2.568v.634a2.134 2.134 0 00-1.242.769c-.35.44-.528.928-.528 1.355 0 .624.32 1.125.694 1.472.651.604 1.573.742 2.25 1.213.366.26.595.553.595.862 0 .163-.117.562-.357.861-.239.3-.56.517-1.02.517-.295 0-.621-.119-.884-.301-.263-.183-.45-.433-.51-.616a.41.41 0 00-.5-.249.412.412 0 00-.25.502c.135.407.44.748.817 1.01.274.19.592.34.934.406v.628h.786V52.9a2.133 2.133 0 001.242-.77c.35-.439.528-.927.528-1.354 0-.677-.46-1.177-.928-1.51-.666-.505-1.59-.615-2.175-1.145-.265-.245-.437-.531-.437-.892 0-.164.118-.563.357-.862.239-.3.56-.517 1.02-.517.295 0 .622.113.884.296.263.182.45.432.51.615a.41.41 0 00.501.25.412.412 0 00.25-.502c-.136-.408-.441-.749-.818-1.01a2.447 2.447 0 00-.934-.4v-.628z"
      fill="#fc1c88"
    />
    <path
      d="M35.717 43.194h57.862v3.871H35.717zm0 7.983h57.862v3.871H35.717z"
      fill="#e4e7ea"
    />
    <path
      d="M100.579 88.75H12A1.75 1.75 0 0110.25 87V67.774c0-.966.784-1.75 1.75-1.75h88.579c.967 0 1.75.784 1.75 1.75V87a1.75 1.75 0 01-1.75 1.75z"
      fill="#fff"
      stroke="#e4e5e6"
      strokeWidth={0.5}
    />
    <path
      d="M23.501 70.29c3.914 0 7.072 3.178 7.072 7.1s-3.158 7.094-7.072 7.094-7.072-3.172-7.072-7.094 3.159-7.1 7.072-7.1zm-.393 2.568v.634a2.133 2.133 0 00-1.242.77c-.35.438-.528.927-.528 1.354 0 .624.32 1.126.694 1.472.651.605 1.573.742 2.25 1.213.366.26.595.553.595.862 0 .164-.117.562-.357.862-.239.299-.56.516-1.02.516-.295 0-.621-.119-.884-.301s-.45-.432-.51-.616a.41.41 0 00-.5-.249.412.412 0 00-.25.502c.135.407.44.748.817 1.01.274.19.592.34.934.406v.628h.786v-.634a2.133 2.133 0 001.242-.77c.35-.439.528-.927.528-1.354 0-.676-.46-1.177-.928-1.509-.666-.506-1.59-.615-2.175-1.146-.265-.245-.437-.531-.437-.892 0-.164.118-.562.357-.862.239-.299.56-.517 1.02-.517.295 0 .622.113.884.296.263.182.45.432.51.615a.41.41 0 00.501.25.412.412 0 00.25-.502c-.136-.408-.441-.749-.818-1.01a2.447 2.447 0 00-.934-.4v-.628z"
      fill="#fc1c88"
    />
    <path
      d="M35.717 71.581h57.862v3.871H35.717zm0 7.983h57.862v3.871H35.717z"
      fill="#e4e7ea"
    />
    <path
      clipRule="evenodd"
      d="M169.059 174.801l6.806 15.99h3.087l-4.095-16.774zm-34.769 0l6.806 15.99h3.086l-4.094-16.774zm-51.934 15.99h3.087l6.806-15.99-5.798-.784zm34.769 0h3.087l6.806-15.99-5.798-.784z"
      fill="#aad5ff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M86.152 137.381v38.716l40.251.086 6.619-38.298zm3.065 3.097l40.171.432-5.566 32.204-34.605-.074z"
      fill="#aad5ff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M138.97 113.582l-10.819 62.601h47.2l10.82-62.601z"
      fill="#c3e4ff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M126.278 113.582l-10.819 62.601h46.627l10.82-62.601z"
      fill="#d6eeff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M114.718 176.183h55.503a5.13 5.13 0 005.13-5.129v-11.821a5.13 5.13 0 00-5.13-5.129h-55.503a5.13 5.13 0 00-5.131 5.129v11.821a5.13 5.13 0 005.131 5.129z"
      fill="#c3e4ff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M85.943 176.183H135.1v-22.079H85.943z"
      fill="#c3e4ff"
      fillRule="evenodd"
    />
    <path
      d="M142.755 91.488c6.8.95 3.951 8.789 2.04 13.022-2.243 4.968-.278 8.3-.278 8.3l10.51-3.736c-3.857-4.911.403-7.646-.646-13.501-.941-5.252-6.047-7.622-9.274-7.51-1.61.055-2.928.47-3.971 1.003a1.54 1.54 0 00-.114.064c-1.906-1.959-4.544-3.13-7.594-3.13-6.27 0-11.904 4.953-11.904 11.53 0 6.575 5.083 11.907 11.354 11.907s11.354-5.332 11.354-11.908c0-2.248-.529-4.305-1.477-6.04z"
      fill="#0b096f"
    />
    <path
      clipRule="evenodd"
      d="M131.769 109.751s2.331.069 3.325-.474l-3.202 2.012z"
      fill="#cf3e83"
      fillRule="evenodd"
    />
    <path
      d="M123.076 100.953c.35 2.709 1.257 6.525 3.496 8.016 1.188.79 3.352.888 5.197.781l.422 5.244 6.019-2.48s-.579-5.787-.829-8.006c1.209-1.097 3.271-1.606 3.274-3.471 0-.646-.376-1.764-1.769-1.767-1.868-.002-1.601 2.24-1.601 2.24a.963.963 0 01-.695.002c-1.85-.077-6.995-.852-10.493-6.836-.408 2.014-1.257 4.525-3.021 6.277z"
      fill="#fcbda4"
    />
    <path
      clipRule="evenodd"
      d="M126.7 101.505l-1.335 3.238 1.548-.031z"
      fill="#f49e7c"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M128.121 101.645c.033.647.413 1.151.848 1.126.436-.025.762-.57.729-1.217s-.413-1.151-.849-1.125c-.436.025-.762.57-.728 1.216zm-4.092-.103c.034.647.414 1.151.849 1.126.436-.025.762-.57.729-1.217s-.413-1.151-.849-1.126-.762.57-.729 1.217z"
      fill="#0d0b6d"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M127.367 106.035l-.074.229-.073.228h.001l.002.001.004.001.014.004a1.206 1.206 0 00.198.037c.128.015.308.021.522-.012.432-.068.987-.294 1.53-.898l-.357-.321c-.468.521-.922.694-1.247.745-.165.025-.3.02-.392.01a1.125 1.125 0 01-.126-.023l-.004-.001z"
      fill="#0b096f"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M131.772 109.751s2.332.069 3.326-.475l-3.202 2.013z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.403}
    />
    <path
      clipRule="evenodd"
      d="M141.142 139.196l1.246-.018-.004-.061c-.429.03-.844.055-1.242.079z"
      fill="#c83820"
      fillRule="evenodd"
    />
    <path
      d="M115.752 152.713l4.113.516 6.625-10.372.242-3.448 10.093-.15 4.308-.063h.009c.398-.024.813-.049 1.242-.08 5.426-.379 12.944-1.435 13.46-4.359.935-5.296-6.144-15.575-6.981-16.766l-.079-.114c-1.186-1.697-2.38-3.016-3.495-3.718-2.167-1.367-4.2-1.667-6.131-1.661l-.517-3.753-7.879 1.088.429 3.12c-2.313.222-3.887.675-5.36 2.028-4.731 4.347-5.079 20.628-5.079 20.628z"
      fill="#ffb027"
    />
    <path
      clipRule="evenodd"
      d="M136.825 139.259v.072s1.807.004 4.308-.135z"
      fill="#c83820"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M124.975 133.092c.628 1.763 1.293 3.628 1.504 6.306l.797-.062c-.22-2.794-.934-4.796-1.57-6.579-.214-.601-.42-1.177-.594-1.751-.689-2.26-.969-4.624.445-8.665l-.755-.264c-1.471 4.207-1.191 6.745-.455 9.163.191.625.407 1.232.628 1.852z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.201}
    />
    <path
      d="M126.027 138.133s-.647.165-.66.573c0 .115 3.946.862 3.946.862l-.859.051-.893-.043s-.464.087-.49.472c-.009.153.812.317 1.768.442 1.486.196 2.555.023 3.6-.262.088-.025.173-.047.254-.068 1.077-.283 1.556-.335 2.94-1.09.614-.335 1.519-.999 1.897-1.335l-.998-3.695-1.375-.47s-.638-.25-1.716-.45c-.677-.124-1.337-.075-2.036-.151l.397 1.456c.045.032.096.142.135.183-.03.025-.059.053-.093.084-.285.261-.825.723-3.147 1.304-.465.116-2.028.137-2.028.137-.46.066-1.425.156-1.491.698-.017.134.151.279.151.279s-.606.042-.643.591c-.015.216 1.341.432 1.341.432z"
      fill="#fcbda4"
    />
    <path
      clipRule="evenodd"
      d="M142.921 123.46l-.684.414 3.554 5.89-9.003 3.566.294.744 9.881-3.914z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.2}
    />
    <path
      d="M124.873 136.581c.975-.731 2.172-1.524 2.676-1.44.615.102-.406 1.778-1.142 2.868 1.332.437 3.103 1.106 3.414 1.658.216.383-.519.56-1.439.637.874.352 1.642.744 1.837 1.09.25.444-.775.611-1.887.667 1.01.384 1.961.834 2.182 1.224.372.661-2.086.709-3.441.687l.446 1.5a.917.917 0 00.978.651l4.784-.521a.918.918 0 00.78-1.174l-4.36-14.647a.918.918 0 00-.978-.651l-4.784.52a.919.919 0 00-.78 1.175z"
      fill="#20262d"
    />
    <path
      clipRule="evenodd"
      d="M125.812 135.914c.708-.47 1.389-.831 1.737-.773.61.101-.388 1.749-1.123 2.839l.012.039c1.328.437 3.074 1.1 3.383 1.648.216.383-.519.56-1.439.637.874.352 1.642.744 1.837 1.09.25.444-.775.611-1.887.667 1.01.384 1.961.834 2.182 1.224.281.499-1.052.649-2.305.683l.412 1.385a.917.917 0 00.978.65l4.784-.521a.917.917 0 00.78-1.174l-4.36-14.647a.918.918 0 00-.978-.651l-4.784.521a.918.918 0 00-.78 1.174z"
      fill="#585c62"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M128.545 131.12c.144.48.453.807.692.731.238-.077.315-.528.172-1.008s-.453-.807-.691-.731c-.239.077-.316.528-.173 1.008zm.724 2.485c.144.48.453.807.692.731.238-.077.315-.528.172-1.008s-.452-.807-.691-.731c-.239.077-.316.528-.173 1.008z"
      fill="#20262d"
      fillRule="evenodd"
    />
    <path
      d="M106.712 188.253l.465 4.067s-8.659 2.272-11.914 5.652l16.142.028-.604-11.647zm-18.58-18.902l-1.86 3.663s-8.507-2.896-13.101-1.87l13.35 8.869 6.085-9.988z"
      fill="#0b096f"
    />
    <path
      d="M110.996 187.376l-4.289 1.707.037 3.376 4.384-.162zm-18.8-16.558l-4.535-.948-1.836 2.847 3.76 2.295 2.61-4.194z"
      fill="#ffb027"
    />
    <path
      d="M98.813 164.972l2.22 24.121h10.282l-.457-35.022 19.626.135c5.598 0 11.014-4.813 10.625-10.407l-.61-5.696-29.971-8.863c-5.549-1.256-7.472.403-11.07 6.813l-15.882 32.59 8.725 5.837z"
      fill="#20262d"
    />
    <path
      clipRule="evenodd"
      d="M135.1 137.381v38.716l40.251.086 6.619-38.298zm3.066 3.097l40.171.432-5.566 32.203-34.605-.073z"
      fill="#aad5ff"
      fillRule="evenodd"
    />
  </React.Fragment>
);

// ------------------------------
// Progress
// ------------------------------

export const MediumProgress = createIllustration(
  describeWithOptions(
    'MediumProgress',
    'Illustration of a woman checking items off a large list of todo items.'
  ),
  <React.Fragment>
    <path
      clipRule="evenodd"
      d="M146.412 22.485c38.293 18.8 56.574 64.2 47.14 105.918-7.952 35.167-47.344 45.868-82.817 51.861-36.699 6.2-80.394 11.249-98.697-21.197-19.891-35.264 0-80.216 28.414-109.097 28.96-29.437 68.964-45.65 105.96-27.485z"
      fill="#f2f3f4"
      fillRule="evenodd"
    />
    <g mask="url(#prefix__a)">
      <path
        clipRule="evenodd"
        d="M53.358 199.361c0 .353 20.972.639 46.842.639s46.842-.286 46.842-.639-20.972-.64-46.842-.64-46.842.287-46.842.64z"
        fill="#e4e7ea"
        fillRule="evenodd"
      />
    </g>
    <g mask="url(#prefix__b)">
      <path
        clipRule="evenodd"
        d="M146.646 129.283h-92.49a3.016 3.016 0 01-3.007-3.007V3.006A3.015 3.015 0 0154.156 0h92.49a3.015 3.015 0 013.007 3.006v123.27a3.016 3.016 0 01-3.007 3.007"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M146.646 128.783h-92.49v1h92.49zm-92.49 0a2.515 2.515 0 01-2.507-2.507h-1a3.516 3.516 0 003.507 3.507zm-2.507-2.507V3.006h-1v123.27zm0-123.27A2.515 2.515 0 0154.156.5v-1a3.515 3.515 0 00-3.507 3.506h1zM54.156.5h92.49v-1h-92.49zm92.49 0a2.516 2.516 0 012.507 2.506h1A3.515 3.515 0 00146.646-.5zm2.507 2.506v123.27h1V3.006zm0 123.27a2.516 2.516 0 01-2.507 2.507v1a3.516 3.516 0 003.507-3.507z"
        fill="#e4e5e6"
        mask="url(#prefix__c)"
      />
    </g>
    <g clipRule="evenodd" fillRule="evenodd">
      <path
        d="M77.47 53.464h61.878V51.07H77.47zm0 5.006h43.592v-2.394H77.47zm0 56.928h42.25v-3.292H77.47z"
        fill="#e4e7ea"
      />
      <path
        d="M64.537 49.785c-2.74 0-4.987 2.246-4.987 4.985 0 2.74 2.246 4.985 4.987 4.985 2.74 0 4.986-2.245 4.986-4.985s-2.246-4.985-4.986-4.985zM57.55 54.77c0-3.844 3.142-6.985 6.987-6.985 3.844 0 6.986 3.14 6.986 6.985 0 3.844-3.142 6.985-6.986 6.985-3.845 0-6.987-3.14-6.987-6.985zm6.987 34.802c-2.74 0-4.987 2.246-4.987 4.985 0 2.74 2.246 4.986 4.987 4.986 2.74 0 4.986-2.246 4.986-4.986s-2.246-4.985-4.986-4.985zm-6.987 4.985c0-3.844 3.142-6.985 6.987-6.985 3.844 0 6.986 3.14 6.986 6.985s-3.142 6.986-6.986 6.986c-3.845 0-6.987-3.142-6.987-6.986zm6.987-24.879c-2.74 0-4.987 2.246-4.987 4.986s2.246 4.985 4.987 4.985c2.74 0 4.986-2.246 4.986-4.985 0-2.74-2.246-4.986-4.986-4.986zm-6.987 4.986c0-3.845 3.142-6.986 6.987-6.986 3.844 0 6.986 3.141 6.986 6.986 0 3.844-3.142 6.985-6.986 6.985-3.845 0-6.987-3.14-6.987-6.985z"
        fill="#1a69fe"
      />
      <path
        d="M77.47 73.358h61.878v-2.394H77.47zm0 5.006h43.592v-2.395H77.47zm0 14.887h61.878v-2.394H77.47zm0 5.006h43.592v-2.394H77.47z"
        fill="#e4e7ea"
      />
      <path
        d="M71.483 30.158l-8.414 9.729-5.144-4.067 1.24-1.569 3.644 2.88 7.162-8.281zm.001-19.893l-8.414 9.728-5.145-4.066 1.24-1.57 3.644 2.88 7.162-8.28z"
        fill="#1a69fe"
      />
      <path
        d="M77.47 12.461h61.878V9.434H77.47zm0 6.332h43.592v-3.028H77.47v3.027zm0 13.562h61.878v-3.028H77.47zm0 6.331h43.592v-3.028H77.47z"
        fill="#e4e7ea"
      />
      <path
        d="M63.537 114.752v3.607h2v-3.607h3.608v-2h-3.608v-3.607h-2v3.607h-3.608v2z"
        fill="#1a69fe"
      />
      <path
        d="M70.593 67.844l.393-1.264s.222-.894.35-1.89c.129-.995-.239-2.314.878-3.828 1.116-1.514-.829-.788-1.396-.079-.474.592-.668 2.054-1.172 2.472a2.473 2.473 0 01-.425-.55l-3.631-5.989a.403.403 0 00-.468-.247l-.218.054a.405.405 0 00-.279.53c.435 1.23 1.824 4.398 1.758 4.413l-1.996 2.957s.172 1.972 1.153 3.323c.415.573 1.117 1.214 1.501 1.573"
        fill="#fcbda4"
      />
      <path
        d="M87.354 93.77s-12.268-6.962-14.81-9.711c-2.834-4.02-5.95-16.237-5.95-16.237l3.947-.368 6.005 12.767 13.327 8.726zm20.717 32.538l-2.79-1.151 2.646-15.053-4.127-8.649 5.965-3.411s2.949 8.314 3.031 11.031c.144 4.756-4.725 17.233-4.725 17.233z"
        fill="#fcbda4"
      />
      <path
        d="M111.499 99.773l-7.949 2.705-2.362-9.365 6.235-1.898z"
        fill="#ffb027"
      />
      <path
        d="M82.014 82.69l-1.13 10.161 4.545 2.286s1.633 3.576 2.85 5.43c1.787 2.726 3.39 9.975 3.39 9.975h14.695l.094-5.688s3.633-13.562.13-15.095c-3.582-1.57-5.332-1.113-10.581-1.105-4.941.008-13.993-5.965-13.993-5.965z"
        fill="#ffb027"
      />
      <path
        d="M105.66 184.315l-7.281 2.543-8.191-54.34a47.625 47.625 0 01.946-19.959l.535-2.017h10.612l2.248 39.704z"
        fill="#364150"
      />
      <path
        d="M117.052 186.512l-7.615-.589-4.908-35.677-6.35-39.704h8.185l2.78 4.149a18.604 18.604 0 013.07 8.692zm-10.918 6.481l-5.295 6.386h-7.372l4.835-3.332 2.032-5.859-.08-2.921 4.763-2.439z"
        fill="#364150"
      />
      <path
        d="M104.993 185.299l.508 3.063-5.168 1.825-.244-3.2z"
        fill="#fc1c88"
      />
      <path
        d="M117.372 192.993l-5.295 6.386h-7.373l4.836-3.332 2.031-5.859-.08-2.921 4.764-2.439z"
        fill="#364150"
      />
      <path
        d="M116.138 184.573l.53 3.047-5.091 1.768-.269-3.181z"
        fill="#fc1c88"
      />
      <path
        d="M107.249 186.955l-9.672 1.784-.508-2.758 9.671-1.784zm11.114-.564l-9.671 1.625-.508-2.513 9.671-1.625z"
        fill="#272636"
      />
      <path
        d="M108.037 79.542c-1.52 4.922-6.743 7.68-11.664 6.16a9.328 9.328 0 115.504-17.822c4.922 1.52 7.68 6.741 6.16 11.662z"
        fill="#20262d"
      />
      <path
        d="M112.256 70.681a5.17 5.17 0 11-9.88-3.051 5.17 5.17 0 019.88 3.052z"
        fill="#20262d"
      />
      <path d="M90.334 77.956l-2.675 2.93 1.605.626z" fill="#f49e7c" />
      <path
        d="M93.48 87.3s-4.036-1.742-4.51-3.294c-1.332-4.37 4.979-12.942 4.979-12.942l7.614 9.31s-1.214 9.139-1.243 9.139l-6.759-.08z"
        fill="#fcbda4"
      />
      <path
        d="M90.126 77.977c-.197.398-.13.831.15.968.28.136.667-.076.864-.474s.13-.832-.15-.968c-.28-.137-.667.075-.864.474z"
        fill="#0b096f"
      />
      <path
        d="M101.94 81.44c-2.403 1.73-5.646 1.496-7.932-.368a6.295 6.295 0 01-.525-.473 6.824 6.824 0 01-.758-.887c-2.19-3.041-1.616-7.198 1.283-9.285.279-.201.569-.376.868-.523 2.808-1.395 6.369-.5 8.35 2.249 2.169 3.012 1.624 7.118-1.204 9.225a1.374 1.374 0 01-.082.062z"
        fill="#20262d"
      />
      <path
        d="M103.952 98.713l-10.903.2-.425-21.831 15.831-.29.323 16.572c.057 2.904-2.104 5.3-4.826 5.35z"
        fill="#20262d"
      />
      <path d="M101.875 122.453l1.142 3.289 1.526 24.589z" fill="#0d0d11" />
      <path
        d="M92.587 80.71s-.2-2.007 1.211-2.005c1.052.001 1.336 1.002 1.335 1.58-.003 1.952-2.127 2.246-2.87 3.659"
        fill="#fcbda4"
      />
      <path
        d="M88.706 83.074l.088-.322.088-.321h-.002l-.002-.001-.003-.001-.005-.001h-.003.017c.02 0 .061 0 .117-.017.108-.03.301-.122.533-.411l.52.417c-.306.382-.613.562-.87.635a1.058 1.058 0 01-.421.034.665.665 0 01-.035-.007l-.013-.003-.005-.001h-.002l-.001-.001z"
        fill="#0c245f"
      />
    </g>
  </React.Fragment>
);

// ------------------------------
// Reconcile
// ------------------------------

export const MediumReconcile = createIllustration(
  describeWithOptions(
    'MediumReconcile',
    'Illustration of a man and a woman walking while holding their phones. In the background there are trees and stylised cards displaying dollar symbols.'
  ),
  <React.Fragment>
    <path
      d="M200 112.446a24.8 24.8 0 00-2.374-10.577 24.652 24.652 0 00-6.651-8.532 24.462 24.462 0 00-9.644-4.838 24.366 24.366 0 00-10.774-.21 24.437 24.437 0 00-9.822 4.461 24.638 24.638 0 00-6.974 8.268 24.809 24.809 0 00-.821 21.142l-.073-.08a24.702 24.702 0 004.466 6.953l.016.019c.151.165.303.329.458.49a24.427 24.427 0 007.891 5.532 24.31 24.31 0 009.401 2.04l-.829 45.284h2.56l-.518-29.888 3.702-1.962-.565-1.079-3.161 1.675-.243-14.032a24.445 24.445 0 0016.972-7.421A24.755 24.755 0 00200 112.446zm-52.08-12.025a29.053 29.053 0 00-2.782-12.396 28.884 28.884 0 00-7.795-10 28.66 28.66 0 00-11.302-5.669 28.555 28.555 0 00-12.626-.244 28.657 28.657 0 00-11.511 5.226 28.873 28.873 0 00-8.171 9.69 29.075 29.075 0 00-.963 24.777l-.085-.095a28.942 28.942 0 005.233 8.149l.02.022a28.654 28.654 0 009.784 7.058 28.482 28.482 0 0011.016 2.39l-.971 53.069h3l-.607-35.026 4.339-2.299-.662-1.265-3.705 1.963-.285-16.444a28.645 28.645 0 0019.889-8.697 29.01 29.01 0 008.184-20.209zM65.393 89.11a33.079 33.079 0 00-3.166-14.107 32.874 32.874 0 00-8.87-11.378 32.616 32.616 0 00-12.862-6.452 32.496 32.496 0 00-14.368-.279 32.598 32.598 0 00-13.099 5.949 32.85 32.85 0 00-9.3 11.025 33.09 33.09 0 00-1.095 28.196l-.097-.107a32.948 32.948 0 005.955 9.273l.023.025c.2.22.403.439.61.654a32.59 32.59 0 0010.523 7.377 32.406 32.406 0 0012.537 2.721l-1.104 60.391h3.413l-.69-39.859 4.937-2.616-.754-1.44-4.215 2.234-.325-18.713a32.6 32.6 0 0022.634-9.896 33.015 33.015 0 009.313-22.998z"
      fill="#E8F6FF"
    />
    <path
      d="M60.99 103.253c23.669 0 42.855-19.308 42.855-43.126C103.845 36.308 84.659 17 60.991 17S18.136 36.309 18.136 60.127s19.187 43.126 42.855 43.126z"
      fill="#DCEEFF"
    />
    <path
      d="M29.348 31.321a43.385 43.385 0 00-1.53 29.72 43.098 43.098 0 0017.96 23.641 42.64 42.64 0 0028.898 6.31 42.779 42.779 0 0026.081-14.027 43.132 43.132 0 01-10.711 15.082 42.791 42.791 0 01-16.013 9.164 42.582 42.582 0 01-18.356 1.553 42.684 42.684 0 01-17.308-6.343 42.993 42.993 0 01-13.064-13.07A43.301 43.301 0 0118.9 65.97a43.392 43.392 0 011.436-18.482 43.205 43.205 0 019.012-16.168z"
      fill="#AAD5FF"
      opacity={0.2}
    />
    <path
      d="M61.108 60.127h.118l2.12 122.271h-4.474l2.236-122.271z"
      fill="#B4DAFE"
    />
    <path
      d="M126.538 181.254s.155-3.26 3.325-2.881l-3.325 2.881zm-.895-3.103a1.59 1.59 0 001.586-1.596c0-.882-.71-1.597-1.586-1.597-.876 0-1.587.715-1.587 1.597s.711 1.596 1.587 1.596zm.189 1.092h-.448v3.155h.448v-3.155zm-109.229 1.56s.155-3.26 3.324-2.881l-3.324 2.881zm-.896-3.102c.876 0 1.587-.715 1.587-1.597a1.59 1.59 0 00-1.587-1.596 1.59 1.59 0 00-1.586 1.596c0 .882.71 1.597 1.586 1.597zm.19 1.092h-.448v3.154h.448v-3.154zm26.679 2.235s.154-3.26 3.324-2.881l-3.324 2.881zm-.896-3.102c.876 0 1.586-.715 1.586-1.596 0-.882-.71-1.597-1.586-1.597-.876 0-1.587.715-1.587 1.597 0 .881.71 1.596 1.587 1.596zm.19 1.092h-.448v3.154h.448v-3.154z"
      fill="#DDD"
    />
    <path
      d="M111.648 34.018l3.182-2.562c-2.472-.274-3.488 1.083-3.903 2.157-1.932-.807-4.034.25-4.034.25l6.367 2.326a4.848 4.848 0 00-1.612-2.171zm40.107 13.692l3.182-2.562c-2.472-.274-3.488 1.083-3.903 2.156-1.932-.806-4.034.251-4.034.251l6.367 2.326a4.84 4.84 0 00-1.612-2.171z"
      fill="#F2F3F4"
    />
    <path
      d="M169.947 182.437s.155-3.26 3.325-2.881l-3.325 2.881zm-29.779 0s.155-3.26 3.324-2.881l-3.324 2.881zm-108.592 0s.155-3.26 3.325-2.881l-3.325 2.881zm151.805 0s.155-3.26 3.324-2.881l-3.324 2.881zm-6.269 0s.155-3.26 3.324-2.881l-3.324 2.881zm-12.932 0s-.155-3.26-3.324-2.881l3.324 2.881zm-51.498 0s-.154-3.26-3.324-2.881l3.324 2.881zm-42.765 0s-.154-3.26-3.324-2.881l3.324 2.881zm-45.451 0s-.155-3.26-3.325-2.881l3.325 2.881zm172.403 0s-.154-3.26-3.324-2.881l3.324 2.881z"
      fill="#DDD"
    />
    <path
      d="M177.614 182.663s-.155-3.261-3.325-2.882l3.325 2.882z"
      fill="#DDD"
    />
    <path
      d="M135.666 99.08H98.333a3.75 3.75 0 01-3.75-3.75V52.46a3.75 3.75 0 013.75-3.75h37.333a3.75 3.75 0 013.75 3.75v42.87a3.75 3.75 0 01-3.75 3.75z"
      fill="#fff"
      stroke="#E4E5E6"
      strokeWidth={0.5}
    />
    <path
      d="M108.333 55.153c4.058 0 7.333 3.296 7.333 7.366 0 4.069-3.275 7.36-7.333 7.36S101 66.587 101 62.518c0-4.07 3.275-7.366 7.333-7.366zm-.408 2.663v.658c-.553.11-.992.43-1.287.798-.364.456-.548.963-.548 1.406 0 .647.332 1.168.72 1.527.675.627 1.631.77 2.332 1.259.38.269.618.573.618.894 0 .17-.122.583-.37.894-.248.31-.582.536-1.058.536-.306 0-.645-.124-.917-.313-.273-.189-.466-.448-.529-.638a.425.425 0 00-.519-.26.427.427 0 00-.258.521c.14.423.456.777.847 1.048.283.198.613.353.968.422v.651h.815v-.657a2.21 2.21 0 001.288-.799c.363-.456.547-.962.547-1.405 0-.702-.476-1.22-.962-1.566-.691-.525-1.649-.638-2.255-1.188-.275-.255-.453-.552-.453-.926 0-.17.122-.584.37-.894.248-.31.582-.536 1.057-.536.306 0 .645.117.918.306.272.19.465.449.528.639a.426.426 0 00.52.258.427.427 0 00.258-.52c-.14-.423-.457-.777-.847-1.048a2.538 2.538 0 00-.969-.415v-.652h-.814z"
      fill="#FC1C88"
    />
    <path d="M101 75.233h32v5.355h-32zm0 9.371h32v5.355h-32z" fill="#E4E7EA" />
    <path
      d="M185.667 99.08h-37.334a3.75 3.75 0 01-3.75-3.75V52.46a3.75 3.75 0 013.75-3.75h37.334a3.75 3.75 0 013.75 3.75v42.87a3.75 3.75 0 01-3.75 3.75z"
      fill="#fff"
      stroke="#E4E5E6"
      strokeWidth={0.5}
    />
    <path
      d="M158.333 55.153c4.059 0 7.333 3.296 7.333 7.366 0 4.069-3.275 7.36-7.333 7.36S151 66.587 151 62.518c0-4.07 3.275-7.366 7.333-7.366zm-.408 2.663v.658c-.553.11-.992.43-1.287.798-.364.456-.548.963-.548 1.406 0 .647.333 1.168.72 1.527.675.627 1.631.77 2.332 1.259.38.269.618.573.618.894 0 .17-.122.583-.37.894-.248.31-.582.536-1.058.536-.306 0-.645-.124-.917-.313-.273-.189-.466-.448-.529-.638a.425.425 0 00-.519-.26.427.427 0 00-.258.521c.14.423.456.777.847 1.048.283.198.613.353.968.422v.651h.816v-.657c.553-.11.992-.43 1.287-.799.363-.456.547-.962.547-1.405 0-.702-.476-1.22-.962-1.566-.691-.525-1.649-.638-2.255-1.188-.275-.255-.453-.552-.453-.926 0-.17.122-.584.37-.894.248-.31.582-.536 1.057-.536.306 0 .645.117.918.306.272.19.465.449.528.639a.426.426 0 00.52.258.427.427 0 00.258-.52c-.14-.423-.457-.777-.847-1.048a2.538 2.538 0 00-.969-.415v-.652h-.814z"
      fill="#FC1C88"
    />
    <path d="M151 75.233h32v5.355h-32zm0 9.371h32v5.355h-32z" fill="#E4E7EA" />
    <path
      d="M86.774 105.356a8.727 8.727 0 01.001.341h.001l.003 1.529.016 11.237-15 .023-.018-12.767h.018a7.565 7.565 0 011.495-5.094 4.054 4.054 0 01-3.022-3.925c-.004-2.241 1.796-4.06 4.02-4.064 2.224-.004 4.03 1.81 4.033 4.052 0 .349-.043.687-.125 1.01.35-.05.706-.077 1.069-.078 4.142-.006 7.504 3.373 7.51 7.548l-.001.188z"
      fill="#20262D"
    />
    <path
      d="M79.214 105.169a3.861 3.861 0 00.707.155c.178.024.361.035.547.035 1.18-.002 2.21-.482 2.762-1.195.03.114.063.225.1.335.02.056.04.114.064.169.148.375.345.723.582 1.033a4.01 4.01 0 001.207 1.053c-.209 1.508-.722 3.536-1.928 4.345-.664.445-1.871.5-2.9.44l-.236 2.945s-1.669-.734-2.624-1.278a4.87 4.87 0 01-.418-.259l.112-1.081v-.002l.308-2.955c-.564-.861-2.098-1.054-2.1-2.265 0-.363.21-.991.987-.992 1.042-.002.894 1.258.894 1.258.59.231 1.294-.67 1.936-1.741z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M83.184 107.287l.744 1.819-.864-.017.12-1.802z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M82.391 107.366c-.019.364-.23.647-.474.633-.243-.014-.425-.32-.406-.684.018-.363.23-.646.474-.632.243.014.424.32.406.683zm2.283-.058c-.02.363-.231.647-.474.633-.243-.015-.425-.321-.407-.684.019-.363.23-.647.474-.632.243.014.425.32.407.683zm-1.877 2.477l.056.175.055.175-.002.001-.003.001-.009.002-.026.007a1.098 1.098 0 01-.395.008c-.252-.039-.572-.172-.882-.52l.27-.246c.254.285.497.376.668.403a.73.73 0 00.206.005c.023-.002.041-.006.052-.008l.01-.003h.002-.002z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M80.355 111.539s-1.3.039-1.855-.267l1.786 1.131.07-.864z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.401}
    />
    <path
      d="M90.994 120.708c-.066-.656-.092-1.441.115-1.722.379-.515 2.255-2.074 2.255-2.074l.1 1.301.444-1.528s.491.147.967.398c.425.224.828.547 1.004.673.252.181-.481 2.961-1.004 3.461-.359.343-1.417.609-2.045.743-1.199 1.952-4.395 6.829-6.16 6.426-1.835-.418-3.537-6.88-3.537-6.88l3.094-1.519 1.347 4.184 3.42-3.463zM69.97 134.871l.753 1.941s.114.499.178 1.09c.064.591.089.95.477 1.836.27.617-.605.433-.853.088-.256-.356-.385-1.814-.807-1.526-.42.289-.548 1.757-.454 3.143a.524.524 0 01-.242.458c-.174.101-.428-.756-.428-.756s-.091.301-.368.175c-.098-.044-.39-.628-.39-.628s-.226-.288-.345-.609c-.21-.567-.382-1.619-.341-1.928.095-.729.31-1.959.592-2.64-.166-1.751-.806-8.78-.453-10.115.404-1.528 1.194-3.598 1.194-3.598l3.034 1.798-1.3 2.799-.247 8.472zm10.486-21.823s.81.577 1.416 1.609c.828 1.412.395 2.63-.88 2.632-1.363.003-2.93-.465-3.59-2.548a36.54 36.54 0 00-.648-1.873l3.702.18z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M94.933 117.123c-.279-.162-.545-.283-.675-.252-.228.053.19.656.494 1.053l-.004.015c-.491.199-1.135.495-1.239.711-.072.151.21.2.56.207-.322.156-.602.324-.668.46-.084.175.308.214.73.208-.372.171-.721.365-.795.52-.094.196.413.221.888.203l-.122.537a.348.348 0 01-.354.272l-1.82-.081a.349.349 0 01-.324-.427l1.29-5.684a.348.348 0 01.354-.272l1.821.08a.35.35 0 01.323.428l-.459 2.022z"
      fill="#020101"
      fillRule="evenodd"
    />
    <path
      d="M95.305 117.353c-.387-.254-.859-.526-1.047-.482-.23.054.196.667.501 1.064-.492.199-1.145.497-1.25.715-.072.151.21.201.56.207-.322.156-.603.324-.668.461-.084.175.308.213.73.207-.373.171-.721.366-.795.52-.125.26.805.218 1.317.177l-.132.582a.347.347 0 01-.354.271l-1.82-.08a.35.35 0 01-.324-.428l1.29-5.684a.347.347 0 01.354-.271l1.821.08a.35.35 0 01.323.428l-.507 2.233z"
      fill="#585C62"
    />
    <path
      clipRule="evenodd"
      d="M93.783 115.365c-.043.186-.151.318-.244.295-.091-.023-.132-.193-.09-.379.043-.187.152-.319.244-.296.092.024.132.193.09.38zm-.213.964c-.043.186-.152.318-.244.295-.092-.023-.132-.193-.09-.379.043-.187.152-.319.244-.296.092.023.132.193.09.38z"
      fill="#020101"
      fillRule="evenodd"
    />
    <path
      d="M77.974 112.928l-1.22-.06s.315.819.649 1.873c.66 2.083 2.226 2.551 3.59 2.548 1.274-.002 1.707-1.22.88-2.632a5.723 5.723 0 00-1.383-1.584c1.609.109 2.61.313 3.538 1.19 1.767 1.67 3.197 4.749 3.786 7.79l-3.229 1.452-1.15 4.479-8.448-.13s.074-.82-.109-2.006c-.237-1.55-1.094-2.707-1.094-2.707l-.85 1.302-5.284-3.14c1.73-3.18 4.143-6.459 5.752-7.502 1.137-.738 2.178-.923 3.195-.933.462-.004.927.027 1.377.06z"
      fill="#FFB027"
    />
    <path
      clipRule="evenodd"
      d="M84.294 124.612c-.327.988-.667 2.016-.781 3.478l-.726-.057c.121-1.56.502-2.71.836-3.719.118-.358.23-.698.324-1.033.353-1.269.485-2.594-.295-4.837l.688-.243c.83 2.39.7 3.869.308 5.278-.108.387-.23.757-.354 1.133zM73.69 123.04l1.96-2.993.608.405-1.96 2.993-.608-.405z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.203}
    />
    <path
      d="M92.33 177.474l.565 2.179s4.485-1.961 6.905-1.094l-8.017 5.108-2.022-6.096 2.57-.097zm-27.195-6.55l-2.505 2.547s.227 1.388.238 2.994c.017 2.326-.3 4.603-.3 4.603L59 172.762l5.265-4.415.87 2.577z"
      fill="#20262D"
    />
    <path
      d="M89.887 178.043l2.543-.201.465 1.811-2.12.928-.888-2.538zm-25.659-9.698l.275 3.228-1.873 1.898-1.488-2.537 3.086-2.589z"
      fill="#FC1C88"
    />
    <path
      d="M83.148 138.403c.512 2.263 1.123 4.944 1.85 8.11 4.734 20.618 7.744 31.997 7.744 31.997l-.43.132-.002.001-2.284.702-.006.001-1.832.564s-5.504-13.213-10.013-25.465a44.69 44.69 0 01-3.06 5.103c-6.107 8.787-11.6 14.412-11.6 14.412l-.597-1.109v-.001l-1.352-2.511-.012-.022-.59-1.096s8.988-9.597 12.732-27.977c-.695-2.383-1.156-4.332-1.272-5.61-.342-3.771 2.078-7.157 2.58-7.815h8.498c.058.477.46 4.695-.354 10.584z"
      fill="#DD036C"
    />
    <path
      clipRule="evenodd"
      d="M92.742 178.51l-.43.132-.002.001-2.284.702-.006.001-1.832.564s-5.504-13.213-10.013-25.465c-1.781-4.842-3.408-9.534-4.478-13.201-.695-2.383-1.156-4.332-1.272-5.61-.342-3.771 2.078-7.157 2.58-7.815h5.797c.291 1.375.956 4.447 2.346 10.584a2856.22 2856.22 0 001.85 8.11c4.734 20.618 7.744 31.997 7.744 31.997z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      d="M34.88 106.697l-.096-3.338s4.034.323 4.898-.127c0 0 1.054-5.464-.204-8.49l-.025-.117-8.514-1.001-.53 4.852c-.287-.85-2.601-1.755-3.22-.538-1.34 2.639 3.453 4.416 3.453 4.416l-.486 4.383"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M34.784 103.359l-2.72-.586 2.707 1.839.013-1.253z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.4}
    />
    <path
      clipRule="evenodd"
      d="M37.028 97.905l.94 2.311-1.127.014.187-2.325z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M35.956 98.562a.57.57 0 11-1.12.204.57.57 0 111.12-.204zm2.957 0a.57.57 0 11-1.12.204.57.57 0 111.12-.204zm-3.21 2.419l.156-.097.156-.097v-.001.001l.002.003a.837.837 0 00.057.075c.042.052.107.121.192.188.17.133.42.258.754.234l.025.369a1.44 1.44 0 01-1.004-.312 1.618 1.618 0 01-.313-.325l-.017-.026-.006-.008-.001-.002v-.001h-.001v-.001z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M30.46 98.527a3.88 3.88 0 00-1.747-1.06l.08-1.672 4-.7c-.276 1.865-1.346 2.883-2.332 3.432z"
      fill="#FFAC4B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.714 95.395c-.36-.344-2.708-.451-5.531-.233a38.26 38.26 0 00-1.868.19c-1.925.242-3.34.588-3.571.892-.256-3.798 2.058-6.06 5.087-6.27 1.987-.138 3.79.642 4.868 2.266.552.832.916 1.888 1.015 3.155z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.76 95.47h-.001a.13.13 0 00-.045-.075c-.36-.345-2.708-.451-5.531-.233-.657.051-1.286.115-1.868.19.828-.792 2.342-2.042 4.129-2.603.764-.24 1.539-.415 2.255-.51 1.74-.231 3.135.007 3.205.915.09 1.18-1.844 2.17-2.144 2.316z"
      fill="#121212"
      fillRule="evenodd"
    />
    <path
      d="M43.708 176.571l.776 2.52s6.063-2.505 9.182-1.555l-10.51 6.131-2.736-6.921 3.288-.175zm-28.584-7.477l-3.4 3.139s.505 2.089.718 4.059c.308 2.852.119 5.426.119 5.426l-5.895-10.359 7.277-5.44 1.18 3.175z"
      fill="#20262D"
    />
    <path
      d="M40.594 177.291l3.25-.294.64 2.094-2.69 1.13-1.2-2.93zm-26.701-11.375l.374 3.978-2.543 2.339-2.019-3.126 4.188-3.191z"
      fill="#2BEDA6"
    />
    <path
      d="M38.02 136.888l9.066 40.813-2.497.642h-.001l-2.908.748-.014.003-1.006.259s-4.62-14.671-8.687-27.759a45.068 45.068 0 01-3.358 4.784c-8.912 11.079-14.364 15.814-14.364 15.814l-.811-1.23-.002-.003-1.95-2.957-1.409-2.138s12.203-11.596 17.694-27.908c-.965-3.176-1.634-5.443-1.806-6.168-.984-4.137-1.004-6.032-1.004-6.183h14.78a61.547 61.547 0 01-1.724 11.283z"
      fill="#20262D"
    />
    <path
      clipRule="evenodd"
      d="M47.086 177.701l-2.497.642h-.001l-2.907.748-.015.003-1.006.259s-4.62-14.671-8.686-27.759a2374.57 2374.57 0 01-4.2-13.638c-.966-3.176-1.635-5.443-1.807-6.168-.984-4.137-1.004-6.032-1.004-6.183h10.55l2.506 11.283 9.067 40.813z"
      fill="#364150"
      fillRule="evenodd"
    />
    <path
      d="M42.82 124.44l-1.094-9.226-3.147.413v5.233l1.095 5.095 1.231 5.371 3.01-.551-1.094-6.335z"
      fill="#FCBDA4"
    />
    <path
      d="M42.407 115.754l-2.152 1.15-.533 9.02H24.87l-.25-9.1-4.696-3.535s2.215-4.471 6.005-6.25c.987-.463 2.229-.709 3.47-.826 2.488-.236 4.969.038 5.372.087l.057.007.209.064.003.001c.201.062.391.123.572.182 2.514.828 3.31 1.499 4.718 3.483 1.339 1.887 2.078 5.717 2.078 5.717z"
      fill="#FC1C88"
    />
    <path
      clipRule="evenodd"
      d="M28.814 114.408l-2.97 3.472-1.327-.904.206-.306 1.056.719 2.757-3.222.278.241z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.2}
    />
    <path
      clipRule="evenodd"
      d="M36.34 123.29s.469.12.477.415c0 .084-2.858.625-2.858.625l.623.037.646-.032s.337.063.355.342c.007.111-.588.229-1.28.32-1.077.142-1.851.017-2.609-.19a7.052 7.052 0 00-.184-.049l.616-3.96c.206.189.597.524 2.28.944.336.084 1.469.1 1.469.1.333.048 1.032.113 1.08.505.012.097-.11.202-.11.202s.44.03.466.428c.011.157-.971.313-.971.313z"
      fill="#18181C"
      fillRule="evenodd"
    />
    <path
      d="M40.073 127.682l2.434 1.542.45-3.819 1.092 5.322c.626.822 1.348 1.792 1.452 2.026.187.424.451 2.479.406 2.878-.045.4-1.398 2.119-1.398 2.119-.755-.233-.194-1.13-.194-1.13s-.723.519-1.008.491c-2.682-.268-2.452-1.583-2.377-1.744.167-.363.857.11.857.11s-1.086-2.543-.801-4.412c-.245-.546-.591-2.615-.913-3.383zm-6.679-19.304c-2.476-.147-3.63-1.587-3.996-2.165 2.488-.236 4.969.038 5.372.087.095.025.184.048.266.071l.003.001c.345.095.565.168.565.168l.007.014c.07.173.74 1.997-2.217 1.824z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M35.105 119.412c-.282-.163-.55-.284-.681-.254-.23.054.19.661.497 1.06l-.003.015c-.495.201-1.145.498-1.25.715-.072.152.213.202.565.209-.324.156-.607.325-.673.463-.085.176.31.215.735.208-.375.173-.727.368-.801.523-.095.198.417.223.895.205l-.123.54a.351.351 0 01-.356.274l-1.837-.081a.352.352 0 01-.326-.431l1.301-5.718a.35.35 0 01.357-.273l1.836.08c.219.01.375.216.327.431l-.463 2.034z"
      fill="#020101"
      fillRule="evenodd"
    />
    <path
      d="M34.69 123.115a.351.351 0 01-.357.273l-1.837-.081a.351.351 0 01-.326-.43l1.301-5.719a.351.351 0 01.357-.273l1.836.081a.351.351 0 01.327.43c-.434 1.906-.869 3.812-1.301 5.719z"
      fill="#585C62"
    />
    <path
      clipRule="evenodd"
      d="M33.945 117.643c-.043.187-.153.32-.246.297-.093-.023-.133-.194-.09-.382.042-.187.152-.32.245-.297.093.023.134.194.09.382zm-.215.969c-.043.188-.153.321-.245.298-.093-.024-.134-.195-.091-.382.043-.188.153-.321.245-.297.093.023.134.194.091.381z"
      fill="#020101"
      fillRule="evenodd"
    />
    <path
      d="M29.004 120.232l.72-.247s.463-.181 1.244-.325c.49-.09.846-.055 1.352-.109l-.172 1.105a.551.551 0 00-.09.082c.021.017.043.038.067.06.207.189.598.524 2.28.944.337.084 1.47.1 1.47.1.332.048 1.032.113 1.08.505.012.097-.11.202-.11.202s.439.03.466.428c.011.157-.972.313-.972.313s.47.12.478.415c0 .084-2.858.625-2.858.625l.622.036.647-.031s.336.063.355.342c.007.111-.589.229-1.281.32-1.077.142-1.85.017-2.608-.19a7.052 7.052 0 00-.184-.049c-.78-.205-1.127-.243-2.13-.789a5.741 5.741 0 01-.3-.179c-2.575.244-10.377.846-11.159-.763-1.546-3.181 2.524-9.336 2.524-9.336l4.505 3.152-1.432 2.434 5.486.955z"
      fill="#FCBDA4"
    />
  </React.Fragment>
);

// ------------------------------
// Relax
// ------------------------------

export const MediumRelax = createIllustration(
  describeWithOptions(
    'MediumRelax',
    "Illustration of a man taking a stroll with his dog. The dog's lead is held by a quadcopter."
  ),
  <React.Fragment>
    <path
      d="M190.309 28.777c16.282 20.618 9.812 57.995-2.999 86.498-12.886 28.449-32.133 48.079-57.095 61.859-24.963 13.78-55.585 21.822-78.824 12.06-23.238-9.763-38.98-37.221-46.634-67.183-7.658-30.017-7.122-62.487 9.434-83.213C30.746 18.07 63.29 9.148 99.16 6.643c35.788-2.439 74.873 1.46 91.148 22.134z"
      fill="#F2F3F4"
    />
    <path
      clipRule="evenodd"
      d="M71.147 39.233c.775 0 1.404-.628 1.404-1.402v-3.936h-2.81v3.936c0 .774.63 1.402 1.406 1.402zm25.024-4.516c0 .001 0 .002.926-.049l.926-.05v.019l.002.027v.074a2.784 2.784 0 01-.014.226c-.018.184-.059.43-.147.717-.178.58-.544 1.313-1.278 2.025-1.468 1.424-4.263 2.637-9.543 2.637v-1.85c5.039 0 7.27-1.161 8.25-2.112.49-.475.703-.93.798-1.24a1.873 1.873 0 00.08-.434v-.005.016zm-29.166 4.576v3.544c0 1.24.502 2.362 1.316 3.175a4.483 4.483 0 003.18 1.315 4.494 4.494 0 004.497-4.49v-3.544h1.854v3.544c0 3.5-2.843 6.34-6.35 6.34a6.34 6.34 0 01-4.492-1.858 6.315 6.315 0 01-1.86-4.482v-3.544h1.855z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M78.255 39.293v3.544c0 1.24.502 2.362 1.316 3.175a4.483 4.483 0 003.18 1.315 4.494 4.494 0 004.497-4.49v-3.544h1.854v3.544c0 3.5-2.843 6.34-6.35 6.34a6.34 6.34 0 01-4.492-1.858 6.315 6.315 0 01-1.86-4.482v-3.544h1.855z"
      fill="#49A2FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M87.19 42.807H65.91a3.407 3.407 0 01-3.41-3.403A3.407 3.407 0 0165.91 36h21.28a3.407 3.407 0 013.41 3.404 3.407 3.407 0 01-3.41 3.403z"
      fill="#2041B6"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M70.099 42.81H65.74a3.407 3.407 0 01-3.41-3.404 3.407 3.407 0 013.41-3.404h4.36a3.407 3.407 0 013.41 3.404 3.407 3.407 0 01-3.41 3.404zm14.126-7.205l.927-.028.927-.029v.029a3.074 3.074 0 01-.005.223 5.035 5.035 0 01-.674 2.233c-.765 1.299-2.283 2.445-5.05 2.445v-1.85c2.162 0 3.044-.842 3.45-1.53a3.187 3.187 0 00.425-1.486V35.6v.005z"
      fill="#49A2FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M55.23 34.606s0-.002.926.05l.926.052v-.019.005l.005.073a1.8 1.8 0 00.077.355c.097.307.314.761.82 1.238 1.013.957 3.318 2.122 8.506 2.122v1.849c-5.418 0-8.28-1.21-9.782-2.628-.752-.71-1.13-1.444-1.313-2.027a3.652 3.652 0 01-.152-.721 2.728 2.728 0 01-.014-.304v-.027l.001-.011v-.007z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M56.11 39.248a1.404 1.404 0 01-1.404-1.402V33.91h2.81v3.936c0 .774-.63 1.402-1.405 1.402z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M85.3 39.116a1.404 1.404 0 01-1.405-1.402v-3.935h2.81v3.935c0 .774-.63 1.402-1.405 1.402z"
      fill="#49A2FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M97.098 39.26a1.404 1.404 0 01-1.405-1.403v-3.935h2.81v3.935c0 .774-.63 1.402-1.405 1.402z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M55.58 33.91v-3.12h.926v3.12h-.927zm15 0v-3.12h.926v3.12h-.927zm26.25 0v-3.12h.926v3.12h-.927z"
      fill="#49A2FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M56.043 30.79h-5.07c0-.612 1.208-1.14 2.948-1.378a817.77 817.77 0 012.122 1.379z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M56.092 28.455c1.761-.244 3.69.073 4.885.97l-.557.739c-.935-.702-2.588-1.017-4.2-.793l-.128-.916zm14.688.287c1.762-.245 3.69.073 4.886.97l-.558.738c-.934-.7-2.587-1.017-4.2-.792l-.128-.916zm14.66-.611c1.774-.14 3.68.292 4.82 1.258l-.6.705c-.892-.756-2.523-1.17-4.146-1.041l-.073-.922zm11.371.584c1.762-.244 3.69.073 4.886.97l-.558.739c-.934-.701-2.587-1.017-4.2-.793l-.128-.916z"
      fill="#12171B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M61.111 30.79c0 .569-1.033 1.06-2.568 1.32l-2.5-1.32h5.069z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M84.836 33.775v-3.121h.927v3.12h-.927z"
      fill="#49A2FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M85.3 30.655h-5.069c0-.613 1.207-1.14 2.947-1.379.946.613 2.122 1.379 2.122 1.379zm5.069 0c0 .568-1.034 1.06-2.569 1.32l-2.5-1.32h5.069zm-19.222.115h-5.07c0-.612 1.208-1.14 2.948-1.379.946.613 2.121 1.38 2.121 1.38zM76.216 30.77c0 .568-1.034 1.06-2.569 1.32l-2.5-1.32h5.069zm20.882.032h-5.07c0-.613 1.208-1.14 2.948-1.379.946.613 2.122 1.379 2.122 1.379zm5.069 0c0 .568-1.034 1.06-2.569 1.32l-2.5-1.32h5.069z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M69.939 39.293c0 .896-.29 1.623-.648 1.623-.358 0-.648-.727-.648-1.623s.29-1.623.648-1.623c.358 0 .648.727.648 1.623z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M68.487 40.916h.804V37.67h-.804v3.246z"
      fill="#3366E9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M69.134 39.293c0 .896-.29 1.623-.647 1.623-.358 0-.648-.727-.648-1.623s.29-1.623.648-1.623c.357 0 .647.727.647 1.623z"
      fill="#FFB027"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M97.881 32.979c-1.762.245-3.69-.073-4.885-.97l.557-.739c.935.702 2.587 1.017 4.2.793l.128.916zm-26.629.151c-1.762.244-3.69-.073-4.885-.97l.557-.739c.935.701 2.587 1.017 4.2.793l.128.916zm-21.285-1.777c-.164-.4-.078-.813.21-1.17l.722.58c-.111.138-.09.2-.074.24.035.086.149.223.406.378.503.304 1.323.539 2.127.613l-.085.92c-.892-.082-1.861-.343-2.523-.742-.325-.197-.637-.464-.783-.819zm28.926-.148c-.165-.4-.078-.814.21-1.17l.722.58c-.112.138-.09.2-.074.24.035.085.148.222.406.377.503.305 1.323.54 2.127.613l-.085.921c-.893-.082-1.862-.343-2.523-.743-.325-.197-.638-.464-.783-.818z"
      fill="#12171B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.877 144.803l-.783-.495-.783-.496.002-.002.098-.155.295-.467c.26-.412.643-1.022 1.137-1.813.987-1.583 2.415-3.89 4.176-6.787a872.28 872.28 0 0013.716-23.382c10.679-18.878 23.251-42.84 30.898-63.278l1.737.647c-7.7 20.577-20.33 44.643-31.02 63.54a874.826 874.826 0 01-13.745 23.431 704.237 704.237 0 01-5.329 8.626l-.297.471-.102.16z"
      fill="#0051BE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M72.501 47.325l-.872.313-.873-.313h1.745zm-.872 3.35c-.391 1.337-.828 3.006-1.127 4.666-.336 1.862-.48 3.611-.255 4.855.111.618.298 1.019.51 1.254.182.202.434.341.872.341.437 0 .69-.139.872-.341.212-.235.398-.636.51-1.254.224-1.243.08-2.993-.255-4.855-.3-1.66-.736-3.33-1.127-4.666zm0-3.037l-.873-.313-.001.004-.003.01-.013.034-.046.131c-.04.114-.096.28-.167.49-.14.42-.334 1.017-.55 1.735-.43 1.43-.95 3.352-1.3 5.284-.343 1.907-.54 3.927-.254 5.51.143.796.424 1.573.956 2.163.56.622 1.329.954 2.25.954.923 0 1.69-.332 2.252-.954.531-.59.812-1.367.956-2.162.285-1.584.089-3.604-.255-5.51-.349-1.933-.87-3.854-1.3-5.285a58.488 58.488 0 00-.763-2.356l-.012-.034-.005-.012s0-.002-.872.311z"
      fill="#0051BE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.326 142.225c-.787 1.591-2.29 2.454-3.356 1.93l2.847-5.76c1.066.524 1.294 2.24.509 3.83zm1.347 13.476s3.082 3.664 2.719 5.722c-.363 2.058-4.714 5.616-4.714 5.616l-2.363 4.33a.796.796 0 00.273 1.053 1.56 1.56 0 002.182-.527l1.721-2.941 7.647-6.522a3.367 3.367 0 001.182-2.561v-5.367l-8.647 1.197z"
      fill="#001F68"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M53.497 153.611c.038 3.453-1.58 7.539-2.363 9.31l-.16-.16s-.043-4.825-6.75-5.616c-4.67-.551-7.185.83-10.302 1.785-.342.106-.69.206-1.052.297-1.07.273-2.239.473-3.598.519-5.982.198-9.825-1.87-9.825-1.87s-.598-2.217-1.87-4.341c-.238-.4-.502-.795-.789-1.173-.972-1.28-2.224-2.349-3.777-2.604-11.55-1.897-12.293-6.447-11.816-8.827.183-.915.547-1.509.547-1.509l1.425.394 8.74 2.42s.764-1.34 2.573-1.386c1.626-.041 3.25 1.078 5.76 2.33.275.135.558.273.854.412 1.003.468 2.141.94 3.46 1.364 2.497.801 5.002 1.027 7.617 1.004.193-.002.384-.005.578-.009 4.007-.091 8.282-.707 13.17-.709 2.56 0 4.916 1.92 6.306 4.374.71 1.254 1.169 2.647 1.272 3.995z"
      fill="#0054A9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.34 150.944s2.616 2.831 1.46 4.505c-1.417 2.053-2.438 3.862-2.787 5.593-.635 3.142 7.751 10.098 7.751 10.098s1.405-1.561-.453-3.596l-3.4-5.378 6.985-4.739-9.557-6.483z"
      fill="#0054A9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.265 142.475a.687.687 0 11-1.373-.001.687.687 0 011.373.001z"
      fill="#E4E7EA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.56 141.757c-1.332 1.175-3.05 1.406-3.838.517l4.822-4.253c.787.889.347 2.562-.984 3.736z"
      fill="#0054A9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M58.608 165.466v6.32c0 .478-.495.866-1.104.866h-.483c-.236 0-.427-.151-.424-.337l.057-3.879c0-.451-.229-.885-.637-1.204l-5.527-4.325c.997-1.771 3.054-5.857 3.005-9.31.006.056.426 9.98 4.616 11.077.376.098.497.482.497.792z"
      fill="#001F68"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M48.074 145.919c.107.238 3.265 2.678 2.462-.176-.803-2.854-6.53-5.766-6.53-5.766s-.535-1.367 1.472-1.011c2.007.357 9.47 2.496 9.11 8.439-.358 5.943-10.154-1.486-10.154-1.486h3.64zm4.528 12.363l-2.03 6.524a.48.48 0 00.023.346l1.418 2.516c.134.238.16.516.07.772l-1.357 3.857a.77.77 0 01-.69.407H48.78c-.276 0-.469-.258-.375-.503l1.248-3.236c.167-.433.06-.918-.276-1.253l-2.942-2.934a1.156 1.156 0 01-.28-.55l-2.701-13.534 9.15 7.588z"
      fill="#0054A9"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.169 139.881c0 .734-.548 1.328-1.224 1.328-.283 0-.544-.105-.75-.278.182-.915.546-1.508.546-1.508l1.426.394c.002.02.002.042.002.064z"
      fill="#001F68"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.59 154.323c0 .666-.194 1.206-.432 1.206s-.431-.54-.431-1.206c0-.666.193-1.206.431-1.206s.431.54.431 1.206z"
      fill="#FFC100"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.622 155.529h.536v-2.412h-.536v2.412z"
      fill="#FFC100"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.054 154.323c0 .666-.194 1.206-.432 1.206s-.43-.54-.43-1.206c0-.666.192-1.206.43-1.206s.432.54.432 1.206z"
      fill="#FFB027"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.403 143.173c-2.305 2.375-3.849 6.152-4.011 10.45l-.907-.994c.256-4.064 1.751-7.619 3.943-9.905.314.147.636.299.975.449z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M49.45 138.907s2.6.424 3.536 2.234l-3.535-2.234z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.088 172.666c0 .293-16.39.531-36.61.531-20.218 0-36.609-.238-36.609-.531 0-.294 16.39-.532 36.61-.532 20.219 0 36.61.238 36.61.532zm105.05-.945c0 .292-14.547.529-32.491.529s-32.491-.237-32.491-.529c0-.293 14.547-.53 32.491-.53s32.491.237 32.491.53z"
      fill="#DFE1E3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M123.829 163.295l-1.558 2.764s-6.486-4.507-10.396-4.191l10.786 9.914 4.988-7.435-3.82-1.052zm44.086-3.305l3.864 4.011-1.513 5.243-4.958 2.553h7.655l4.952-8.492-8.36-7.048-1.64 3.733z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M143.617 110.076s-5.342-10.32-4.924-13.565c.418-3.245 4.274-8.743 8.501-10.68l4.598 6.985-8.175 17.26z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M159.855 59.223s-5.948 3.41-1.283 6.94l1.283-6.94z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M145.593 86.74l1.47 9.106 3.909-6.4-5.379-2.707z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.401}
    />
    <path
      clipRule="evenodd"
      d="M127.305 164.944l-2.161 3.136-2.873-2.021 1.288-2.298 3.746 1.183zm42.31-8.687l4.808 4.129-2.644 3.615-2.891-2.989.727-4.755z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M155.691 105.938c-5.08 27.491 18.731 50.319 18.731 50.319l-5.833 7.327s-10.606-10.594-18.246-25.916c-11.333-22.732-5.258-36.519-5.258-36.519l10.606 4.789z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M149.361 103.133l-27.389 61.007 7.132 3.596 32.176-59.275-11.919-5.328z"
      fill="#364150"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M145.085 101.149l2.921-9.945-2.681-4.961s8.119-7.116 15.085-5.178l5.482 1.036s10.568 1.39 13.392 10.32l-11.214 4.242-6.789 11.798"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M179.284 92.42l-.301.122-10.781 4.342-.338.136-6.232 10.829c-.331.107-.669.211-1.013.314l-15.533-7.014 2.921-9.944s.71-4.512 4.253-7.842c2.477-2.325 5.224-2.61 5.492-2.632h.003c.89-.011 1.781.09 2.655.333l5.483 1.037s10.566 1.39 13.391 10.32z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M181.801 105.175c-.73 8.224-24.942 9.554-24.942 9.554l-1.168-5.362a52.566 52.566 0 004.928-1.204c.345-.103.682-.207 1.013-.314 6.409-2.038 10.372-4.634 10.372-4.634l-3.802-6.332 10.782-4.34c1.843 3.49 3.233 7.936 2.817 12.632zM170.364 71.33c.853-.969 4.92-.924 4.696 1.96-.29 3.72-7.078 2.885-7.078 2.885l-1.528 5.88 2.135.69s-7.011 4.268-10.846 2.916c-3.835-1.352.03-4.93.03-4.93l1.687.125 2.32-5.718s-5.685-1.885-6.583-2.967c0 0 1.378-5.753 3.804-9.223l6.232-2.193 7.07 3.605-1.939 6.97z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      d="M175.622 65.134c2.336 6.016-1.81 5.972-1.81 5.972-2.235-.85-3.448.224-3.448.224-3.461-2.208-.742-4.777-.742-4.777-18.605-1.261-12.748-12.258-11.369-12.258 1.378 0 .958 3.876.958 3.876s3.28-6.072 7.378-4.37c2.876 1.194 2.089 5.992 2.089 5.992s2.565-.376 4.838 1.932l1.222-1.891 1.543 1-1.261 1.952 2.095-.882.713 1.698-2.418 1.019c.072.165.143.336.212.513z"
      fill="#0B096F"
    />
    <path
      clipRule="evenodd"
      d="M155.518 111.281c-.096-1.452.19-2.815.488-3.64l.794.29c-.264.729-.527 1.974-.44 3.294.087 1.316.518 2.665 1.596 3.672l-.574.621c-1.285-1.199-1.768-2.782-1.864-4.237z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M161.78 75.138l3.947.744-4.625.927.678-1.67z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.401}
    />
    <path
      clipRule="evenodd"
      d="M159.911 67.653l-2.202 2.239 1.309.56.893-2.799z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M159.184 67.037a.81.81 0 01-1.035.497.815.815 0 01-.498-1.04l1.533.543zm3.587 1.363a.81.81 0 01-1.035.496.815.815 0 01-.498-1.04l1.533.543zm-4.752 3.73l.203-.413.204-.413h-.002l-.001-.001.004.001a1.573 1.573 0 00.456.122c.262.027.517-.021.714-.25l.696.602c-.462.537-1.068.61-1.503.564a2.488 2.488 0 01-.748-.2l-.014-.008-.005-.002-.002-.001h-.002z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M167.864 97.02l-3.2-4.84 1.417 7.938 1.783-3.099z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.401}
    />
    <path
      clipRule="evenodd"
      d="M161.632 107.849l-.352.613-.661-.299c.344-.103.682-.207 1.013-.314z"
      fill="#FFC700"
      fillRule="evenodd"
    />
  </React.Fragment>
);

// ------------------------------
// Review
// ------------------------------

export const MediumReview = createIllustration(
  describeWithOptions(
    'MediumReview',
    'Illustration of a woman standing and man sitting on an object. Above the them are stylised, larger-than-life paper documents and a dollar symbol.'
  ),
  <React.Fragment>
    <path
      d="M176.562 93.15c1.721 18.534-16.538 38.207-35.143 50.163-18.628 11.893-37.633 16.094-57.777 14.611-20.144-1.483-41.437-8.56-51.477-23.344s-8.801-37.167-1.792-57.906c7.029-20.773 19.87-39.832 37.7-45.723 17.829-5.892 40.605 1.406 62.879 13.8 22.201 12.4 43.917 29.835 45.61 48.4z"
      fill="#F2F3F4"
    />
    <path
      d="M86.982 10.783a1.24 1.24 0 00-.875.384c-.23.24-.356.564-.351.899v66.23c-.005.335.122.658.351.898.23.24.545.379.875.385h47.654a1.24 1.24 0 00.875-.385c.229-.24.356-.563.351-.898v-66.23a1.277 1.277 0 00-.351-.899 1.24 1.24 0 00-.875-.384H86.982z"
      fill="#fff"
    />
    <path
      d="M95.096 21.064a.588.588 0 00-.39.143.463.463 0 00-.16.345v2.24c0 .13.058.254.16.345a.589.589 0 00.39.143h32.461a.588.588 0 00.389-.143.462.462 0 00.161-.345v-2.24a.462.462 0 00-.161-.345.588.588 0 00-.389-.143H95.096z"
      fill="#FC1C88"
    />
    <path
      d="M94.684 29.66a.127.127 0 00-.098.052.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684zm0 3.296a.126.126 0 00-.098.052.201.201 0 00-.04.124v1.257c0 .046.014.09.04.124a.127.127 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684zm0 3.477a.126.126 0 00-.098.051.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.127.127 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.123.127.127 0 00-.098-.052H94.684zm0 6.433a.126.126 0 00-.098.052.201.201 0 00-.04.124v1.257c0 .046.014.09.04.124a.127.127 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684zm0 3.217a.126.126 0 00-.098.052.201.201 0 00-.04.123v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.123.127.127 0 00-.098-.052H94.684zm0 3.217a.127.127 0 00-.098.051.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.127.127 0 00.098.051h33.285a.127.127 0 00.098-.05.2.2 0 00.04-.125v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H94.684zm0 3.216a.126.126 0 00-.098.052.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.051h33.285a.128.128 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684zm0 3.217a.126.126 0 00-.098.051.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H94.684zm0 3.217a.127.127 0 00-.098.051.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.127.127 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H94.684zm0 3.216a.126.126 0 00-.098.052.201.201 0 00-.04.124v1.257a.2.2 0 00.04.123.126.126 0 00.098.052h33.285a.128.128 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684zm0 3.217a.126.126 0 00-.098.051.201.201 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H94.684zm0 3.217a.126.126 0 00-.098.05.2.2 0 00-.04.125v1.257c0 .046.014.09.04.124a.127.127 0 00.098.051h33.285a.128.128 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H94.684z"
      fill="#E4E7EA"
    />
    <path
      d="M72.618 27.863c-.33.006-.645.144-.875.384-.23.24-.356.564-.351.899v66.23a1.27 1.27 0 00.351.898c.23.24.544.379.875.385h47.654c.33-.006.645-.144.874-.385.23-.24.357-.563.352-.898v-66.23a1.273 1.273 0 00-.352-.899 1.237 1.237 0 00-.874-.384H72.618z"
      fill="#fff"
    />
    <path
      d="M80.732 37.513a.588.588 0 00-.39.143.463.463 0 00-.16.345v2.24c0 .13.058.253.16.345a.588.588 0 00.39.143h32.461a.588.588 0 00.389-.143.462.462 0 00.161-.345V38a.462.462 0 00-.161-.345.588.588 0 00-.389-.143H80.732z"
      fill="#FC1C88"
    />
    <path
      d="M80.32 46.109a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.128.128 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.128.128 0 00-.098-.051H80.32zm0 3.296a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.258a.2.2 0 00.04.123.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.123V49.58a.2.2 0 00-.04-.123.127.127 0 00-.098-.052H80.32zm0 3.477a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.051h33.285a.128.128 0 00.098-.05.2.2 0 00.04-.125v-1.257a.2.2 0 00-.04-.124.128.128 0 00-.098-.051H80.32zm0 6.433a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124V59.49a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H80.32zm0 3.217a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257c0 .046.014.091.04.124a.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H80.32zm0 3.216a.126.126 0 00-.098.052.202.202 0 00-.04.124v1.257c0 .046.014.09.04.124a.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H80.32zm0 3.217a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.127.127 0 00.098-.052.2.2 0 00.04-.124V69.14a.2.2 0 00-.04-.124.127.127 0 00-.098-.05H80.32zm0 3.216a.126.126 0 00-.098.052.202.202 0 00-.04.124v1.257c0 .046.014.09.04.124a.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H80.32zm0 3.217a.126.126 0 00-.098.052.202.202 0 00-.04.124v1.257c0 .046.014.09.04.124a.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.128.128 0 00-.098-.052H80.32zm0 3.217a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.051h33.285a.127.127 0 00.098-.05.2.2 0 00.04-.125V78.79a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H80.32zm0 3.216a.126.126 0 00-.098.052.202.202 0 00-.04.124v1.257c0 .046.014.09.04.124a.126.126 0 00.098.051h33.285a.127.127 0 00.098-.051.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.052H80.32zm0 3.217a.126.126 0 00-.098.051.202.202 0 00-.04.124v1.257a.2.2 0 00.04.124.126.126 0 00.098.052h33.285a.128.128 0 00.098-.052.2.2 0 00.04-.124v-1.257a.2.2 0 00-.04-.124.127.127 0 00-.098-.051H80.32z"
      fill="#E4E7EA"
    />
    <ellipse cx={121.6} cy={96.42} fill="#fff" rx={9.141} ry={9.211} />
    <path
      d="M121.6 87.209c5.058 0 9.14 4.124 9.14 9.215s-4.082 9.207-9.14 9.207c-5.059 0-9.141-4.116-9.141-9.207 0-5.09 4.082-9.215 9.141-9.215zm-.509 3.332v.823a2.755 2.755 0 00-1.604.999c-.453.57-.683 1.204-.683 1.758 0 .81.414 1.461.897 1.91.842.786 2.033.964 2.907 1.575.474.337.77.719.77 1.119 0 .213-.152.73-.461 1.118-.309.389-.725.671-1.318.671-.382 0-.804-.154-1.144-.391-.34-.237-.58-.561-.658-.799a.53.53 0 00-.648-.323.534.534 0 00-.322.65c.175.53.569.972 1.056 1.312.354.247.765.441 1.207.527v.815h1.016v-.823a2.759 2.759 0 001.605-.998c.453-.57.682-1.205.682-1.759 0-.878-.593-1.527-1.199-1.958-.861-.657-2.055-.8-2.811-1.487-.343-.319-.565-.69-.565-1.159 0-.212.152-.73.461-1.118.309-.388.726-.671 1.319-.671.381 0 .803.147 1.143.383.34.237.58.562.659.8a.53.53 0 00.648.323.535.535 0 00.321-.651c-.174-.53-.569-.972-1.056-1.311a3.151 3.151 0 00-1.207-.52v-.815h-1.015z"
      fill="#FC1C88"
    />
    <path
      d="M164.665 100.294l.135-4.596s-5.661.444-6.873-.176c0 0-1.48-7.524.286-11.69l.035-.162 11.948-1.38.543 6.941c.402-1.17 3.851-2.676 4.719-.999 1.882 3.634-4.846 6.08-4.846 6.08l.683 6.037"
      fill="#C68642"
    />
    <path
      clipRule="evenodd"
      d="M164.801 95.697l3.818-.807-3.8 2.532-.018-1.725z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.403}
    />
    <path
      clipRule="evenodd"
      d="M161.65 88.186l-1.319 3.182 1.581.02-.262-3.202z"
      fill="#FFB027"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M163.155 89.09a.79.79 0 00.644.917.798.798 0 00.929-.636.789.789 0 00-.644-.916.799.799 0 00-.929.636zm-4.149 0a.789.789 0 00.644.917.799.799 0 00.929-.636.79.79 0 00-.645-.916.798.798 0 00-.928.636z"
      fill="#121212"
      fillRule="evenodd"
    />
    <path
      d="M169.604 90.942a3.59 3.59 0 01.074-.166c.912-1.925 2.327-2.734 3.256-3.07.508-.741.908-1.57 1.041-2.443.422-2.762-.315-5.286-1.96-6.01-1.664-.732-5.606-.365-10.033-.365-5.315 0-5.607-.516-5.607-.516s-4.685 6.52 3.964 6.33c4.533-.099 7.113.014 7.113.014l2.152 6.226z"
      fill="#20262D"
    />
    <path
      clipRule="evenodd"
      d="M162.734 93.492l-.064-.077-.064-.077h-.001l-.006.005-.025.018a1.96 1.96 0 01-.47.236 1.69 1.69 0 01-1.219-.038l-.079.184c.534.224 1.017.16 1.364.043a2.16 2.16 0 00.522-.263l.031-.022.008-.006.002-.002h.001z"
      fill="#252535"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M164.044 92.728s-.44-1.135-2.525-1.05c-2.085.085-2.343 1.491-2.343 1.491l4.868-.441z"
      fill="#121212"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M187.21 149.372h-26.874l-3.522 42.483h40.005l-9.609-42.483z"
      fill="#E4E7EA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M187.21 149.372h-8.265l-4.947 42.483h22.821l-9.609-42.483z"
      fill="#C8CBD1"
      fillRule="evenodd"
    />
    <path
      d="M145.57 157.789c3.02 6.308 7.739 21.62 7.739 21.62l-4.006 1.803s-10.166-16.096-16.378-27.099c.29 2.477.584 5.265.858 8.197.647 6.945 0 21.949-.348 26.283-.219 2.724-3.977 2.153-4.328-.007-.059-.366-.302-1.651-.663-3.567-1.772-9.399-6.409-33.996-6.417-40.019-.003-2.423 4.804-4.6 7.67-2.906 1.968-2.068 5.693-3.26 7.833.156 1.36 2.172 4.593 8.338 8.04 15.539z"
      fill="#C68642"
    />
    <path
      clipRule="evenodd"
      d="M153.023 173.74l-13.751-32.081c-3.294-5.218-12.529 1.062-11.406 4.089 2.55 6.872 15.521 29.119 16.281 31.166l8.876-3.174z"
      fill="#0078C2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M157.132 181.259l-3.954-6.06-6.326 3.598c-2.674 5.674-8.793 11.724-8.793 11.724l.696 1.187 11.448-6.509 3.569-2.821.348.594 3.012-1.713zm-21.885 10.596l-.348-7.194h-7.306c-5.195 3.597-13.566 5.824-13.566 5.824v1.37h13.219l4.522-.685v.685h3.479z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M121.064 147.465c0 9.102 4.389 30.333 4.392 32.338l9.443.007s-2.074-28.417-1.471-28.723c.603-.306 24.717 2.371 31.949 2.371 10.428 0 14.742-6.477 15.092-18.475h-20.658c-4.206.443-26.147 4.802-34.295 6.3-3.488.641-4.452 3.675-4.452 6.182z"
      fill="#0091EA"
      fillRule="evenodd"
    />
    <path
      d="M134.421 139.011l9.855-9.468 3.273 5.578-10.248 5.95c-2.569 3.986-4.078 5.708-4.527 5.167-.378-.457-.205-.957-.045-1.418.124-.359.241-.694.081-.966-.364-.621-2.421-.265-4.359.154-1.938.42-1.49-.518-1.078-1.007 1.832-1.455 4.181-2.785 7.048-3.99zm58.085 13.756c-1.019-2.037-4.491-21.889-4.491-21.889l-7.269.028s6.733 21.407 7.269 22.716c.697 1.702-.487 4.174-1.29 5.85-.124.26-.239.5-.337.715 1.115.491 1.65-.102 2.214-.728.637-.707 1.312-1.454 2.899-.727.613.281 1.194.613 1.761.938 1.958 1.121 3.757 2.151 6.205.664.388-.236.813-1.124-.214-1.818-2.56-1.728-6.248-4.753-6.747-5.749z"
      fill="#C68642"
    />
    <path
      clipRule="evenodd"
      d="M167.357 100.836l-3.009-.508c-5.178 12.741-14.22 24.319-27.125 34.732l9.751 11.668c12.904-14.827 20.857-30.124 20.383-45.892z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M180.469 138.066h-26.786s9.309-22.29 9.309-37.871l8.08-1.186c6.35 10.059 8.143 22.443 9.397 39.057z"
      fill="#F2F3F4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M186.261 145.126h-24.003s3.308-30.456 3.618-40.506l1.953-5.495s1.937-.084 2.883-.116h.528c5.69 10.059 13.897 29.502 15.021 46.117z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M171.249 99.01s18.466 17.813 21.396 50.362h-13.056c2.029-27.406-10.599-48.384-10.599-48.384l2.259-1.979z"
      fill="#433D9D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M178.904 118.538s-.091 20.26-4.001 26.723h8.001l-4-26.723z"
      fill="#000"
      fillOpacity={0.1}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M171.249 99.01s18.466 17.813 21.396 50.362h-13.056c2.029-27.406-10.599-48.384-10.599-48.384l2.259-1.979z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M175.908 134.64l-8.658-3.964v3.964h8.658z"
      fill="#fff"
      fillOpacity={0.2}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M48.599 63.283a7.961 7.961 0 00-7.962 7.962v6.722a7.963 7.963 0 006.76 7.871l.005.098h10.26c1.746-1.705-.226-13.268-1.456-17.1-.174-.544-.343-.934-.509-1.2a7.96 7.96 0 00-7.099-4.352z"
      fill="#191847"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M48.753 80.354c2.291 1.38 4.542 2.048 5.6 1.776 2.65-.683 2.893-10.378.843-14.2-2.05-3.821-12.591-5.487-13.123 2.085-.184 2.628.92 4.974 2.55 6.887L41.699 90.53h8.492l-1.438-10.175z"
      fill="#B28B67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M40.95 70.06c.246-.245.484-.48.721-.692l-.011-.274s2.665-5.457 6.762-5.457c4.094 0 5.389 1.903 6.489 3.521l.003.005c-.576 1.975-2.31 2.774-4.273 3.678-.844.389-1.731.797-2.585 1.327a1.946 1.946 0 10-1.138 3.455c.391 4.203.234 9.002-.932 10.142h-10.26c-.295-5.118 1.029-6.578 2.382-8.07 1.273-1.404 2.571-2.836 2.571-7.37l.27-.266z"
      fill="#191847"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M57.868 70.302c.503 4.258 2.95 6.645 3.464 10.615.662 5.106-2.307 4.788-1.764 8.978.282 2.172-18.664 8.915-24.64 2.475-3.836-4.132-.407-4.945-1.178-10.89-.763-5.885 3.406-7.096 3.004-10.198-.535-4.129 2.36-9.905 7.753-10.608 6.568-.856 12.6 3.193 13.361 9.628z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M49.673 81.083s-1.927.31-2.81-.036l2.874 1.33-.064-1.294z"
      fill="#CF3E83"
      fillRule="evenodd"
    />
    <path
      d="M44.956 77.78c.734.896.652 2.212.403 3.008-.083.273-.563 2.533-.66 2.645-.382.436 5.194 2.06 5.194 2.06l-.217-4.409c1.541-.11 3.325-.424 4.226-1.211 2.681-2.344 1.97-9.17 1.879-9.503l-2.823-2.447s-3.938-1.24-4.408-.435c-.86 1.475-2.5 7.79-4.34 7.332 0 0-.022-1.894-1.571-1.69-1.155.152-1.347 1.123-1.276 1.66.239 1.814 2.606 1.784 3.593 2.99z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M53.027 73.937l1.456 2.55-1.287.142-.17-2.692z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M51.863 74.208c.042.542-.219 1.003-.583 1.029-.364.026-.694-.392-.736-.934-.042-.542.219-1.002.583-1.029.364-.026.693.392.736.934zm3.384-.528c.042.541-.219 1.002-.583 1.028-.364.026-.694-.392-.736-.934-.042-.542.219-1.002.583-1.028.364-.027.693.392.736.933z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M53.095 63.417c.117-.154.243-.302.376-.442.342.252.669.523.977.816a10.204 10.204 0 013.145 6.29h.001l.258 1.965a5.502 5.502 0 01-4.148-1.452 5.445 5.445 0 01-.982-1.221 4.71 4.71 0 01-.117-.206 5.353 5.353 0 01-.445-1.156c-4.54 7.608-7.95 6.813-7.95 6.813l.195-3.812-4.017-3.723s10.23-5.399 12.707-3.872z"
      fill="#19141E"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M53.095 63.417c.117-.154.243-.302.376-.442.342.252.669.523.977.816a10.204 10.204 0 013.145 6.29h.001l.258 1.965a5.502 5.502 0 01-4.148-1.452 5.445 5.445 0 01-.982-1.221 4.71 4.71 0 01-.117-.206 5.353 5.353 0 01-.445-1.156c-4.54 7.608-7.95 6.813-7.95 6.813l.195-3.812-4.017-3.723s10.23-5.399 12.707-3.872zm-.148 14.33l.1.213.1.214h-.001l-.002.001-.003.002a.974.974 0 01-.177.059c-.108.027-.26.052-.444.047-.373-.01-.866-.141-1.388-.59l.305-.359c.439.378.828.47 1.095.477a1.179 1.179 0 00.398-.058.307.307 0 00.017-.006l.002-.001h-.001z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M49.67 81.083s-1.927.31-2.81-.035l2.874 1.328-.064-1.293z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.397}
    />
    <path
      clipRule="evenodd"
      d="M41.275 116.991l23.216 38.813 17.405 32.813h3.749l-29.163-71.626H41.275z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M81.88 187.251c-1.143-.259-2.447.136-2.706 1.277a3.197 3.197 0 00-.095.669c0 .845.282 2.466.282 2.466h17.622s.687-2.271-.793-2.452c-1.48-.181-2.459-.327-2.459-.327l-7.544-3.363a1 1 0 00-1.332.532l-.257.624s-1.37.639-2.227.639c-.144 0-.313-.025-.492-.065z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.75 116.991c-2.192 13.64-6.418 31.065-6.817 31.603-.266.358-9.838 3.566-28.716 9.622l.81 3.306c22.512-3.248 34.374-5.768 35.586-7.56 1.818-2.688 10.894-23.922 14.41-36.971H39.748z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.853 155.359l1.427 5.324c16.838 1.477 27.154.41 30.95-3.201 3.796-3.611 8.123-17.108 12.98-40.491H36.737c-3.077 19.148-4.797 29.123-5.16 29.927-.364.804-7.272 3.617-20.725 8.441z"
      fill="#151B21"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M77.062 183.363l7.23-2.187s-4.751-14.204-11.647-31.262c-6.895-17.058-14.81-32.923-14.81-32.923h-20.42s8.8 20.069 18.659 36.47c9.859 16.4 20.988 29.902 20.988 29.902z"
      fill="#151B21"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M5.39 159.106c.057-1.17-.558-2.386-1.727-2.443a3.177 3.177 0 00-.675.023c-.832.147-2.38.706-2.38.706l3.06 17.354s2.356.282 2.277-1.207c-.079-1.488-.105-2.478-.105-2.478l2.002-8.014a1 1 0 00-.755-1.219l-.659-.145s-.867-1.238-1.016-2.081a2.298 2.298 0 01-.021-.496z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M53.693 95.532l12.675-5.274c2.243-2.151 4.4-3.777 6.472-4.878.617-.183 1.666-.222.518 1.389-1.148 1.61-2.282 3.357-1.846 3.938.436.58 1.742-.026 2.236.915.33.627-1.865 1.326-6.585 2.098l-9.549 7.034-3.92-5.222z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M51.084 94.688c3.52-.038 8.215-.781 13.224-3.96l1.967 4.386c-3.455 3.429-8.313 6.246-12.561 6.127-3.348-.094-5.058-4.143-2.63-6.553z"
      fill="#DD036C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M33.346 124.263c5.233-1.03 20.796 4.204 23.454-1.448 5.257-11.178-4.5-26.648-5.481-39.265h-8.034c-.881 0-6.87 11.479-6.875 18.936-.005 6.81-6.341 11.135-3.064 21.777z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M71.72 100.558l4.414-2.425s.93-3.535 2.222-3.558c.661-.308-.491 2.67.763 2.413 1.255-.259 4.317-2.536 4.844-2.074.781.684.085 2.785-.735 3.83-1.533 1.953-2.802 2.621-5.938 3.495-2.46.686-5.32 2.75-5.32 2.75l-.25-4.431z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M50.52 83.55s-.805 16.107 4.653 17.981c5.457 1.874 19.452-3.106 19.452-3.106s3.273 6.772 3.026 9.655c-31.083 16.237-43.869-4.587-34.114-24.53h6.982z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
  </React.Fragment>
);

// ------------------------------
// Support
// ------------------------------

export const MediumSupport = createIllustration(
  describeWithOptions(
    'MediumSupport',
    'Illustration of a woman sitting at a desk, holding her phone with one hand. On the desk is a laptop and a desk lamp.'
  ),
  <React.Fragment>
    <path
      d="M198.979 124.82c-5.501 23.221-35.743 39.595-63.243 46.452-27.503 6.773-52.312 4.044-76.178-6.056S12.72 137.747 6.58 115.652C.438 93.558 11.112 66.88 28.123 44.576 45.17 22.239 68.579 4.38 92.653 4.569c24.074.189 48.755 18.437 70.74 42.668 21.892 24.209 41.133 54.335 35.586 77.583z"
      fill="#F2F3F4"
    />
    <path
      clipRule="evenodd"
      d="M80.462 86.518l11.356 24.062-3.354 1.583L77.108 88.1l3.354-1.582z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M77.865 85.699L104.5 70l2 3-26.794 15.919-1.841-3.22z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M114.741 73.83h-9.773v-3.71h9.773v3.71z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M82.835 113.56h21.309a3.51 3.51 0 00-3.51-3.509h-14.29a3.51 3.51 0 00-3.51 3.509zM125.957 78.976c0-4.957-4.02-8.976-8.978-8.976-4.959 0-8.979 4.019-8.979 8.976"
      fill="#DCEEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M58.133 201.86h2.012l12.366-82.364h-6.959l-7.42 82.364z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M93.364 201.86h2.012l12.366-82.364h-6.959l-7.42 82.364z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M142.728 88.344h30.084l-7.059 23.266h-30.084l7.059-23.266z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M170.694 89.84l-6.026 19.866h-26.923l6.027-19.865h26.922z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M165.781 95.955l-.287.95h-22.099l.287-.95h22.099zM164.37 97.89l-.287.95h-21.375l.287-.95h21.375zM157.675 99.825l-.287.95h-15.347l.287-.95h15.347z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M113.67 113.524h30.085v-1.914H113.67v1.914z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M143.754 113.524h21.988v-1.914h-21.988v1.914zM172.787 88.344h1.849l-7.059 23.266h-1.849l7.059-23.266z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M50 119.496h113.646v-5.972H50v5.972z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M155.427 119.496h44.338v-5.972h-44.338v5.972zM194.137 201.86h2.013l-7.42-82.364h-6.959l12.366 82.364z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M158.771 201.86h2.013l-7.42-82.364h-6.959l12.366 82.364zM166.884 92.202l-.287.95h-22.099l.287-.95h22.099zM163.943 94.137l-.287.95h-19.688l.287-.95h19.688zM159.344 89.591l-3.76.456-.301-.473.198-.431-.286-.344 3.513-.455.53.317-.444.444.55.486z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M66.157 147.501v.349c0 2.909-2.254 5.266-5.033 5.266H21.697c-6.082 0-10.762-5.841-9.923-12.386l4.452-36.468c.385-3.02 2.76-5.267 5.567-5.267H33.48c2.804 0 5.18 2.247 5.567 5.267l4.452 36.468c.034.26.058.521.072.779l.024-.004s.823 5.996 8.477 5.996h14.087z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M36.554 199h3.768v-44.314h-3.768V199z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M49.952 152.975l-11.692 5.33-11.691-5.33h23.383z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      d="M15.635 91.238c0-2.643 9.912-24.623 22.784-24.233 17.856.542 22.436 28.199 21.618 30.921-.65 2.168-3.787 2.956-17.539 2.572-20.654-.577-26.863-6.893-26.863-9.26z"
      fill="#0B096F"
    />
    <path
      clipRule="evenodd"
      d="M39.678 96.14s-2.718.08-3.876-.553l3.732 2.342.145-1.79z"
      fill="#CF3E83"
      fillRule="evenodd"
    />
    <path
      d="M39.189 78.15c3.133 1.582 8.067 4.48 10.576 8.097-.44 3.123-1.512 7.31-4.03 8.983-1.384.92-3.907 1.033-6.057.909l-.492 6.1-6.806-2.254s.674-7.148.966-9.733c-1.41-1.28-4.023-2.082-4.027-4.254 0-.75.44-2.052 2.062-2.054 2.178-.002 1.869 2.605 1.869 2.605 2.2.856 4.45-5.667 5.939-8.398z"
      fill="#FCBDA4"
    />
    <path
      clipRule="evenodd"
      d="M45.587 86.544l1.556 3.769-1.805-.037.25-3.732z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M43.931 86.708c-.039.753-.482 1.34-.99 1.31-.508-.03-.888-.663-.849-1.416.039-.753.482-1.34.99-1.31.508.03.888.663.849 1.416zM48.7 86.588c-.039.753-.482 1.34-.99 1.31-.508-.03-.888-.663-.85-1.416.04-.753.483-1.34.99-1.31.508.03.889.663.85 1.416z"
      fill="#0D0B6D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M44.787 91.745l.108.337.108.336H45L45 92.42l-.006.002a.7.7 0 01-.073.02 2.328 2.328 0 01-.815.017c-.52-.082-1.182-.354-1.826-1.07l.524-.473c.534.593 1.049.787 1.411.843a1.624 1.624 0 00.55-.007l.024-.006.002-.001h-.002z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.674 96.14s-2.718.08-3.877-.553l3.733 2.342.144-1.79z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.398}
    />
    <path
      clipRule="evenodd"
      d="M41.776 103.167c-1.265-2.138-2.958-3.334-2.958-3.334l-7.737-.373s.659 1.698 1.356 3.88c1.38 4.314 4.651 5.284 7.502 5.279 2.662-.004 3.567-2.528 1.837-5.452zm19.06 12.533c-.139-1.358-.193-2.984.24-3.566.792-1.068 4.711-4.297 4.711-4.297l.21 2.695.927-3.164s1.027.304 2.022.824c.717.375 1.404.883 1.836 1.202.102.076.19.141.26.191.528.375-1.004 6.134-2.096 7.17-.75.711-2.96 1.263-4.273 1.539-2.506 4.043-9.184 14.146-12.873 13.313-3.833-.866-7.39-14.254-7.39-14.254l6.466-3.147 2.815 8.669 7.145-7.175zm-43.93 29.339l1.573 4.021s.24 1.035.373 2.259l.018.163c.121 1.13.203 1.888.977 3.64.565 1.279-1.263.897-1.782.183-.191-.264-.349-.82-.512-1.399-.294-1.037-.608-2.145-1.173-1.762-.88.598-1.145 3.639-.948 6.51.03.451-.283.819-.507.949-.364.21-.894-1.567-.894-1.567s-.19.625-.77.364c-.204-.092-.815-1.301-.815-1.301s-.472-.596-.721-1.261c-.439-1.175-.797-3.354-.713-3.995.2-1.509.649-4.057 1.239-5.469-.348-3.626-1.684-18.187-.947-20.953.843-3.165 2.495-7.454 2.495-7.454l6.34 3.726-2.718 5.797-.515 17.549z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M69.067 108.273c-.583-.334-1.139-.584-1.411-.521-.477.111.395 1.36 1.031 2.182l-.007.031c-1.027.413-2.372 1.025-2.588 1.473-.151.313.439.415 1.17.429-.673.322-1.26.67-1.396.953-.175.363.644.442 1.524.43-.778.354-1.506.757-1.66 1.077-.197.407.863.457 1.855.42l-.255 1.113a.724.724 0 01-.74.563l-3.804-.166a.725.725 0 01-.676-.886l2.696-11.775a.726.726 0 01.74-.563l3.804.167c.453.02.777.444.676.886l-.959 4.187z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      d="M69.843 108.751c-.807-.526-1.793-1.091-2.187-.999-.48.112.41 1.382 1.048 2.203-1.03.413-2.394 1.031-2.612 1.483-.151.313.439.415 1.17.429-.673.322-1.26.67-1.396.953-.175.363.644.442 1.524.43-.777.354-1.506.757-1.66 1.077-.26.539 1.683.452 2.753.366l-.276 1.205a.724.724 0 01-.74.563l-3.805-.166a.725.725 0 01-.676-.886l2.697-11.775a.726.726 0 01.738-.563l3.806.167c.453.02.777.445.676.886l-1.06 4.627z"
      fill="#585C62"
    />
    <path
      clipRule="evenodd"
      d="M66.663 104.632c-.088.385-.316.66-.508.611-.192-.048-.276-.399-.188-.785.089-.386.317-.66.509-.612.192.048.276.4.188.786zM66.219 106.629c-.09.385-.317.66-.51.611-.192-.048-.275-.399-.187-.785.089-.386.316-.66.509-.612.192.048.276.4.188.786z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      d="M31.08 99.46c.815 2.142.66 1.698 1.357 3.88 1.38 4.314 4.651 5.284 7.502 5.279 2.662-.004 3.567-2.528 1.837-5.452-1.114-1.883-2.56-3.035-2.89-3.283 3.363.227 5.456.649 7.395 2.466 3.691 3.46 6.68 9.837 7.91 16.138l-6.746 3.008-2.403 9.277-17.654-.269s.154-1.699-.226-4.155c-.496-3.211-2.286-5.608-2.286-5.608l-1.776 2.697-11.043-6.505c3.615-6.587 8.658-13.379 12.02-15.541 2.376-1.527 4.878-1.91 7.003-1.932z"
      fill="#FC1C88"
    />
    <path
      clipRule="evenodd"
      d="M47.136 122.68c-.687 2.061-1.42 4.257-1.663 7.339l-.704-.055c.25-3.176 1.022-5.49 1.716-7.57.251-.753.492-1.475.694-2.196.76-2.707 1.034-5.536-.623-10.264l.667-.234c1.706 4.869 1.434 7.848.637 10.69-.217.77-.467 1.521-.724 2.29zM25.02 120.757l4.096-6.202.589.39-4.096 6.202-.59-.39z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.203}
    />
    <path
      d="M68.543 187.54l-.542 4.732s10.094 2.644 13.889 6.576l-18.817.033.704-13.552 4.766 2.211zM90.202 165.665l2.168 4.262s9.917-3.37 15.273-2.176l-15.562 10.32-7.094-11.621 5.215-.785z"
      fill="#0B096F"
    />
    <path
      d="M63.549 186.639l5 1.985-.043 3.928-5.11-.187.153-5.726zM85.465 167.372l5.286-1.103 2.14 3.313-4.382 2.669-3.044-4.879z"
      fill="#FC1C88"
    />
    <path
      d="M76.105 161.75l-2.588 28.066H61.53l.532-40.751-22.878.158c-6.526 0-12.839-5.601-12.386-12.11l.711-6.627 34.938-10.313c6.468-1.461 8.71.469 12.904 7.928l18.514 37.92-10.17 6.792-7.591-11.063z"
      fill="#20262D"
    />
    <path
      clipRule="evenodd"
      d="M65.367 132.899l-26.182 16.324 22.878-.158-.532 40.751h11.986l4.109-44.567c1.014-8.109-4.065-12.35-12.259-12.35z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      d="M122 79h-10l-8.5 34.5H131L122 79z"
      fill="url(#prefix__paint0_linear)"
      fillOpacity={0.2}
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="prefix__paint0_linear"
        x1={123.045}
        x2={117.876}
        y1={78.624}
        y2={116.977}
      >
        <stop stopColor="#FFB027" />
        <stop offset={1} stopColor="#FFB027" stopOpacity={0} />
      </linearGradient>
    </defs>
  </React.Fragment>
);

// ------------------------------
// Upgrade
// ------------------------------

export const MediumUpgrade = createIllustration(
  describeWithOptions(
    'MediumUpgrade',
    'Illustration of a man wearing a jet pack launching himself into the sky. Behind the man is a cityscape.'
  ),
  <React.Fragment>
    <g clipPath="url(#prefix__clip0)">
      <g opacity={0.7}>
        <mask
          id="prefix__a"
          width={260}
          x={-48}
          y={20}
          height={180}
          // @ts-ignore Should be `EMaskUnits.USER_SPACE_ON_USE`, but I can't import it for some reason...
          maskUnits="userSpaceOnUse"
        >
          <path
            d="M0 0h259.2v180H0z"
            fill="#C4C4C4"
            transform="matrix(-1 0 0 1 212 20)"
          />
        </mask>
        <g mask="url(#prefix__a)">
          <path
            clipRule="evenodd"
            d="M30.057 143.15H11.75v-38.021l18.308-15.195v53.216z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M122.11 201.2h20.375v-66H122.11v66z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M110.442 157.424h20.374V91.161h-20.374v66.263z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M18.858 201.2h49.436v-68.4H18.858v68.4z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-16.815 201.2h49.437v-68.4h-49.437v68.4z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-48.863 201.2H.573v-22.8h-49.436v22.8zM64.354 201.2h49.436v-38.4H64.354v38.4z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M146.342 69.624V54.195h.7v15.43h-.7z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M182.394 89.839V201.2h-43.07V58.4l16.918 12.35v18.156h14.691v-7.433l11.461 8.366z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M151.7 200.95h37.038V102.8H151.7v98.15z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M188.738 201.2h23.479v-98.4h-23.479v98.4z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M151.7 115.202h8.805v-4.568H151.7v4.568zM160.506 119.724h8.804v-4.568h-8.804v4.568zM169.31 115.202h8.804v-4.568h-8.804v4.568z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M151.7 119.724h8.805v-4.568H151.7v4.568zM160.506 150.558h8.804v-4.568h-8.804v4.568zM191.756 119.724h6.821v-4.568h-6.821v4.568zM178.115 173.601h8.804v-4.568h-8.804v4.568z"
            fill="#E8F6FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M178.115 124.293h8.804v-4.568h-8.804v4.568zM160.506 145.99h8.804v-4.568h-8.804v4.568zM178.115 150.558h8.804v-4.568h-8.804v4.568zM191.758 115.202h6.819v-4.568h-6.819v4.568zM191.757 137.403h6.82v-4.569h-6.82v4.569zM169.31 173.601h8.804v-4.568h-8.804v4.568zM151.7 185.319h8.805v-4.569H151.7v4.569zM160.506 189.887h8.804v-4.568h-8.804v4.568zM151.7 124.293h8.805v-4.568H151.7v4.568z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M78.244 122.96h3.596v-6.418h-3.596v6.418zM78.244 110.125h3.596v-6.418h-3.596v6.418z"
            fill="#E8F6FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M74.707 200.635h30.946V35.56H74.707v165.075z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M105.653 201.2h19.618V35.6h-19.618v165.6z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M74.707 31.753h30.946v-7.547H74.707v7.547z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M80.316 28.748h12.486V21.2H80.316v7.548zM108.675 28.748h12.485V21.2h-12.485v7.548z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M105.653 31.753h19.618v-7.547h-19.618v7.547z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M71.85 35.56h34.443v-3.807H71.851v3.807z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M106.293 35.56h21.835v-3.807h-21.835v3.807zM78.244 200.635h3.596V39.301h-3.596v161.334zM98.337 200.635h3.596V39.301h-3.596v161.334zM91.64 200.635h3.595V39.301H91.64v161.334zM84.942 200.635h3.595V39.301h-3.595v161.334z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M84.942 116.542h3.595v-6.417h-3.595v6.417zM91.64 175.66h3.595v-6.417H91.64v6.417zM91.64 169.243h3.595v-6.418H91.64v6.418z"
            fill="#E8F6FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M98.337 149.973h3.596v-6.417h-3.596v6.417zM78.244 156.485h3.596v-6.417h-3.596v6.417zM98.337 96.94h3.596v-6.417h-3.596v6.418zM78.244 86.856h3.596v-6.418h-3.596v6.418zM91.64 156.408h3.595v-6.418H91.64v6.418z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M78.244 183.035h3.596v-6.417h-3.596v6.417zM91.64 110.125h3.595v-6.418H91.64v6.418zM78.244 129.377h3.596v-6.418h-3.596v6.418zM98.337 72.833h3.596v-6.418h-3.596v6.418zM78.244 62.858h3.596v-6.417h-3.596v6.417zM78.244 69.276h3.596v-6.418h-3.596v6.418z"
            fill="#E8F6FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M91.64 103.707h3.595V97.29H91.64v6.417z"
            fill="#E8F6FF"
            fillRule="evenodd"
          />
          <path
            d="M45.122 105.089v12.671"
            stroke="#C3E4FF"
            strokeWidth={1.165}
          />
          <path
            clipRule="evenodd"
            d="M5.99 122.959h10.95v-9.351H5.99v9.351z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-4.562 201.2h39.187v-82.8H-4.562v82.8z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-.555 200.635h4.541v-78.781h-4.54v78.781zM7.904 200.635h4.54v-78.781h-4.54v78.781zM16.363 200.635h4.54v-78.781h-4.54v78.781zM24.821 201.38h4.541V122.6h-4.541v78.78z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M38.766 122.959h10.951v-9.351H38.766v9.351z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M34.625 201.274h24.841V118.4H34.625v82.874z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M42.99 200.937h4.54V145.4h-4.54v55.537zM51.448 200.937h4.541V145.4h-4.54v55.537z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-.69 201.2h21.504v-46.8H-.69v46.8z"
            fill="#C3E4FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M-34.612 195.192h48.748v-4.023h-48.748v4.023zM-34.612 188.255h48.748v-4.023h-48.748v4.023zM-34.612 181.318h48.748v-4.022h-48.748v4.022zM-34.612 174.382h48.748v-4.023h-48.748v4.023zM-34.612 167.446h48.748v-4.023h-48.748v4.023zM-34.612 160.508h48.748v-4.022h-48.748v4.022z"
            fill="#AAD5FF"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M196.578 156.485h49.436v-9.918h-49.436v9.918zM196.578 184.237h49.436v-16.745h-49.436v16.745z"
            fill="#D6EEFF"
            fillRule="evenodd"
          />
        </g>
      </g>
      <path
        clipRule="evenodd"
        d="M189.953 202.999H41.639c0 .082.48-3.081 0 0 0-4.355 0-9.735 5.311-13.011 8.14-5.021 16.734 3.089 16.597-6.927-.142-10.408-4.831-64.775-4.831-64.775l1.391-4.126s10.882 43.352 13.676 58.136c2.989 15.82 6.256-.41 16.817-.889 9.969-.453 14.613 5.164 16.516 12.075 5.768-1.685 11.086-2.574 15.109 1.285 5.483-13.781 14.519-1.893 13.471-14.804-1.233-15.182-6.046-61.974-6.046-61.974l2.046-2.588s10.319 43.119 14.559 62.235c3.004 13.541 10.725-.956 24.003 5.866 10.407 5.346 7.806 17.796 7.806 17.796s10.906-1.368 11.889 11.701z"
        fill="#B5BABD"
        fillRule="evenodd"
      />
      <path
        d="M110.877 203v-.016c.002-.095.004-.192.004-.287 0-6.429-4.729-11.752-10.892-12.661a12.895 12.895 0 00-3.834.012 12.946 12.946 0 00-7.422-6.47 12.837 12.837 0 00-4.113-.672c-7.122 0-12.896 5.789-12.896 12.927a13.188 13.188 0 00.071 1.358 6.866 6.866 0 00-4.013-1.286c-.599 0-1.179.076-1.733.218A6.935 6.935 0 0060.87 203H110.878z"
        fill="#D7DBDE"
      />
      <path
        clipRule="evenodd"
        d="M181.279 202.841l-.002.159h-13.792c-.002-.053-.002-.107-.002-.159 0-3.134 2.196-5.768 5.169-6.518a7.126 7.126 0 012.742-.14c3.33.478 5.885 3.277 5.885 6.658"
        fill="#D7DBDE"
        fillRule="evenodd"
      />
      <path
        d="M162.916 203a15.043 15.043 0 001.579-6.735 15.083 15.083 0 00-9.902-14.179 14.92 14.92 0 00-5.132-.902c-7.63 0-13.933 5.701-14.906 13.087a9.774 9.774 0 00-5.044-1.391c-.853 0-1.68.109-2.469.312a9.888 9.888 0 00-7.386 9.573l.003.235h43.257z"
        fill="#D7DBDE"
      />
      <path
        clipRule="evenodd"
        d="M60.602 184.375a2.069 2.069 0 01-2.071 2.066 2.069 2.069 0 01-2.071-2.066c0-1.141.927-2.066 2.07-2.066 1.145 0 2.072.925 2.072 2.066M38.385 196.523a1.19 1.19 0 01-1.192 1.189 1.19 1.19 0 110-2.379c.658 0 1.192.533 1.192 1.19M131.208 172.275a2.962 2.962 0 01-2.966 2.958 2.962 2.962 0 01-2.965-2.958 2.962 2.962 0 012.965-2.959 2.963 2.963 0 012.966 2.959M152.578 169.597c0 .675-.548 1.221-1.224 1.221a1.222 1.222 0 110-2.442c.676 0 1.224.547 1.224 1.221M195.036 191.764a2.821 2.821 0 01-2.825 2.817 2.82 2.82 0 01-2.824-2.817 2.821 2.821 0 012.824-2.818 2.821 2.821 0 012.825 2.818"
        fill="#D7DBDE"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M64.385 119.174l-8.913 1.191-3.783-28.18c-.834-6.215 3.109-10.634 3.109-10.634s4.969 3.228 5.803 9.443l3.784 28.18"
        fill="#49A2FF"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M63.59 113.248l-8.913 1.191-2.654-19.768 8.912-1.192 2.654 19.769zM63.876 122.001l-7.166.958-.364-2.71 7.166-.958.364 2.71zM51.336 122.163l4.137-1.798-.696-5.187-3.645 5.468.204 1.517zM68.85 119.823l-4.465-.649-.696-5.187 4.958 4.319.204 1.517z"
        fill="#285FD7"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M128.497 103.014l-68.599 9.168-2.112-15.736 31.63-24.466 36.969 15.299 2.112 15.735z"
        fill="#49A2FF"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M111.007 85.114l2.669 19.88-38.956 5.207-2.67-19.88a7.785 7.785 0 012.957-7.195l14.41-11.145 16.84 6.969a7.797 7.797 0 014.75 6.164"
        fill="#285FD7"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M135.614 108.823l-8.913 1.191-3.783-28.18c-.835-6.215 3.108-10.634 3.108-10.634s4.97 3.228 5.804 9.443l3.784 28.18"
        fill="#49A2FF"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M134.818 102.897l-8.913 1.191-2.654-19.77 8.913-1.19 2.654 19.769zM135.104 111.65l-7.166.958-.364-2.71 7.166-.958.364 2.71zM120.031 102.92l4.137-1.799-.697-5.187-3.644 5.469.204 1.517zM140.079 109.472l-4.465-.649-.697-5.187 4.959 4.319.203 1.517z"
        fill="#285FD7"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M81.733 147.701l2.561 2.77s-5.923 5.43-6.43 9.561l12.746-8.309-6.258-8.613-2.619 4.591z"
        fill="#0B096F"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M84.886 143.925l2.886 4.003-3.478 2.543-2.56-2.77 3.152-3.776z"
        fill="#FC1C88"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M108.431 160.335l2.72 2.614s-2.532 8.669-2.794 12.824l8.867-12.557-6.45-7.618-2.343 4.737z"
        fill="#0B096F"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M111.355 156.38l2.813 3.215-3.016 3.354-2.721-2.614 2.924-3.955z"
        fill="#FC1C88"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M67.662 114.999s14.499-.284 15.35-2.35c1.673-4.061-.318-17.56-.318-17.56l-8.526 1.471 1.466 12.254-9.857 2.134"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M82.864 109.322l-2.104-8.957-6.968 1.311s-.144-10.969 1.642-13.691c1.538-2.343 4.138-5.391 10.68-6.726 9.73-1.984 12.09-.966 15.348 1.516 2.815 2.144 6.686 8.823 6.686 8.823l-7.292 3.975 2.453 8.405-20.445 5.344z"
        fill="#FC1C88"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M72.889 68.931s-2.658 6.186 3.096 6.185l-3.096-6.185z"
        fill="#0B096F"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M84.303 84.026l-.949-3.638s-5.123 1.737-6.468 1.423c0 0-2.32-5.313-2.465-9.462l3.6-5.401 7.688-1.365 2.597 6.596c.098-1.262 3.32-3.633 4.85-1.246 1.971 3.08-3.685 6.324-3.685 6.324l1.454 4.753"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M84.303 81.656l-1.675.606s-.914 5.046 4.151 3.999c4.093-.846 4.782-5.882 4.782-5.882l-2.261.256"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M94.268 80.212s.48-.293 3.236.415c0 0-2.113 7.633 4.101 21.784l-1.032.97s-7.743-9.705-6.305-23.169M77.732 85.209s1.764-1.809 2.916-2.065c0 0-2.787 6.18 1.118 21.509l.87 3.705s-6.666-9.955-4.904-23.149"
        fill="#1E202D"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M80.03 79.438c.176.562 1.534.746 2.323.156 1.748-1.307 1.211-3.037.136-3.01-1.342.036-1.024 1.261-1.648 1.675-.713.473-.941.768-.812 1.179"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M83.363 80.409l4-1.907-3.545 3.614-.455-1.707z"
        fill="#000"
        fillRule="evenodd"
        opacity={0.398}
      />
      <path
        clipRule="evenodd"
        d="M78.482 75.246l-.487 3.487 1.556-.375-1.069-3.112z"
        fill="#F49E7C"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M79.736 75.211c.08.57.487.985.908.926.422-.059.698-.57.618-1.14-.08-.57-.486-.984-.908-.925-.421.058-.698.569-.618 1.139M76.015 76.032c.08.57.487.985.909.926.421-.059.698-.569.618-1.14-.08-.57-.487-.984-.908-.925-.422.059-.699.569-.619 1.14"
        fill="#0B096F"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M82.863 109.322s-18.598 9.879-20.523 15.403c-2.072 5.943 18.789 25.5 18.789 25.5l6.444-4.649-11.795-18.456 22.033-12.121-4.735-8.347-10.213 2.67z"
        fill="#2B2B3B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M91.552 107.051s-1.358 27.169 0 32.741c.728 2.988 17.313 23.795 17.313 23.795l5.335-6.45-11.383-21.477 1.404-32.122-12.67 3.513z"
        fill="#2B2B3B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M95.565 106.277s13.528 2.178 15.369.442c2.949-2.78-3.805-14.565-3.805-14.565l-6.579 3.597 2.588 5.412-7.989.067"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M67.837 117.118l-6.935-9.204 1.338-1.004 6.935 9.205-1.338 1.003zM91.77 96.728l2.448 11.515-1.474.312-2.448-11.515 1.474-.312z"
        fill="#1C2127"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M65.936 112.399c1.395 1.421 1.897 3.28 1.12 4.152-.778.871-2.54.426-3.935-.995-1.396-1.421-1.897-3.28-1.12-4.152.778-.871 2.54-.426 3.935.995"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M65.676 111.225c-.07 1.16-1.313 1.233-1.313 1.233l-.185-2.911 3.853.913-.216 1.998-2.14-1.233zM96.29 101.804s-3.73-2.52-4.64-2.45c-1.096.084-2.694.885-3.27 1.312-.574.426-.117 1.538.24 1.782 0 0-.674.953.188 1.922 0 0-.06.963.845 1.471 0 0 .207.992 1.27 1.027 1.063.034 3.544-.417 5.483-.782"
        fill="#FCBDA4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M79.645 83.966l-17.907 23.572-.334-.252 17.907-23.572.334.252zM90.832 96.827l4.715-16.575.403.114-4.715 16.575-.403-.114z"
        fill="#1C2127"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M91.111 118.635l.16-3.088-8.121 7.441 7.961-4.353z"
        fill="#151B21"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M100.549 95.751l6.58-3.597-5.524 5.804-1.056-2.207zM74.758 101.495l.29 2.429 4.64-1.732-.52-1.527-4.41.83z"
        fill="#000"
        fillRule="evenodd"
        opacity={0.398}
      />
      <path
        d="M89.558 64.276c4.891 3.314 1.685 5.566 1.685 5.566-2.269.608-2.622 2.152-2.622 2.152-4.022.235-3.325-3.353-3.325-3.353-15.555 9.655-18.257-2.143-17.159-2.932 1.1-.789 4.062 2.266 4.062 2.266s-.86-6.679 3.381-7.68c2.977-.702 5.096 3.542 5.096 3.542s2.318-2.237 6.204-.928l-.1-2.041 1.343-.068.126 2.559.262.057 1.315-2.142 1.148.698-1.416 2.304z"
        fill="#0B096F"
      />
    </g>
    <defs>
      <clipPath id="prefix__clip0">
        <path d="M0 0h200v200H0z" fill="#fff" />
      </clipPath>
    </defs>
  </React.Fragment>
);

// ------------------------------
// Downgrade
// ------------------------------

export const MediumDowngrade = createIllustration(
  describeWithOptions(
    'MediumDowngrade',
    'Illustration of a man jogging in a park.'
  ),
  <React.Fragment>
    <path
      clipRule="evenodd"
      d="M178.383 130.346c0 23.02-14.984 35.863-34.5 35.863s-34.5-12.843-34.5-35.863c0-48.47 22.02-104.346 34.5-104.346s34.5 55.877 34.5 104.346"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M146.415 87.641V199.55h-5.25V87.641h5.25zm16.895 49.803l-10.082 10.17-2.475-2.496 10.082-10.171 2.475 2.497zm0-43.26l-10.082 10.17-2.475-2.496 10.082-10.17 2.475 2.496zm-30.338 18.357c0 26.462-21.266 47.913-47.5 47.913-26.233 0-47.5-21.451-47.5-47.913 0-26.462 21.267-47.913 47.5-47.913 26.234 0 47.5 21.451 47.5 47.913"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M88.17 100.687v98.839h-5.25v-98.839h5.25zm19.231 36.929l-10.564 10.657-2.983-2.957 10.565-10.657 2.982 2.957zm0-34.406l-10.564 10.656-2.983-2.957 10.565-10.656 2.982 2.957zm-40.743 15.005l10.577 10.67-2.97 2.995-10.577-10.669 2.97-2.996zm0-17.203l10.577 10.67-2.97 2.995-10.577-10.669 2.97-2.996z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M128.491 196.447l-85.777.454c-4.896-6.275-16.297-21.988-11.708-26.63 3.02-3.054 12.069 6.774 14.512 3.825 2.443-2.947-13.601-21.32-9.527-23.91 7.18-4.563 30.281 28.187 33.263 25.551 3.135-2.772-11.597-22.03-6.407-24.07 6.044-2.375 22.047 27.076 26.67 24.07 2.422-1.576-2.28-11.178 1.215-12.818 6.084-2.86 16.236 24.872 20.552 22.401 2.041-1.17-.255-5.177 2.806-6.174 3.74-1.216 11.274 11.611 14.401 17.301m40.87-10.581c-.125.169-3.934 5.296-4.412 10.016h-6.695c3.161-6.336 10.934-9.937 11.107-10.016"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M17.601 186.349c.126.17 3.935 5.296 4.412 10.017h6.695c-3.16-6.336-10.933-9.938-11.107-10.017m173.783 3.643c-.088.121-2.017 2.714-3.311 5.89h-4.848c3.543-3.752 8.027-5.832 8.159-5.89m-45.116-23.675c-.1.31-5.636 15.715-6.171 29.065h-8.939c.533-6.028-2.133-13.309-2.133-13.309s4.757 3.682 5.987 8.935c0 0 3.691-16.747 11.256-24.691m8.012 17s-5.23 7.001-6.627 12.566h-4.864c1.659-3.435 5.642-10.398 11.491-12.566"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M196.331 162.725c0 11.635-5.514 22.203-18 22.203-12.485 0-18-10.568-18-22.203 0-13.65 9.435-27.223 18-27.223s18 13.573 18 27.223"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M181.041 159.203v40.346h-5.25v-40.346h5.25zm11.036 1.446l-7.433 7.373-2.209-2.266 7.433-7.372 2.209 2.265zm-25.776 2.489l8.672 7.9-2.111 2.358-8.673-7.9 2.112-2.358z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M57.212 171.384l-.68 1.434a51.813 51.813 0 00-4.567 15.529 43.079 43.079 0 00-.356 4.779 27.588 27.588 0 00.022 1.603l.004.074v.015l.001.001v.001l.118 1.582-3.141.238-.118-1.585 1.57-.118-1.57.117v-.004l-.001-.01-.002-.031a18.455 18.455 0 01-.023-.497 32.02 32.02 0 01-.01-1.434c.019-1.231.107-2.99.382-5.138a55.016 55.016 0 014.85-16.494l.68-1.433 2.841 1.371zM28.66 160.966l1.216 1.011c6.762 5.624 11.366 14.108 14.266 21.048a91.577 91.577 0 013.187 8.913c.341 1.138.592 2.061.758 2.702a46.611 46.611 0 01.234.942l.013.053.003.015.002.006-1.536.355 1.536-.354.35 1.549-3.07.707-.351-1.548-.003-.011-.01-.042-.041-.175c-.038-.156-.096-.39-.174-.693a72.643 72.643 0 00-.726-2.587 88.56 88.56 0 00-3.075-8.598c-2.831-6.775-7.192-14.695-13.367-19.831l-1.215-1.01 2.004-2.452z"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M33.79 160.925c.507 2.832-1.357 5.541-4.163 6.052-2.807.512-5.493-1.369-6-4.2-.507-2.831 1.357-5.541 4.164-6.052 2.806-.511 5.493 1.369 6 4.2m27.813 6.416c.507 2.831-1.357 5.541-4.164 6.053-2.806.511-5.492-1.37-6-4.201-.506-2.831 1.358-5.541 4.165-6.052 2.806-.511 5.492 1.369 6 4.2"
      fill="#AAD5FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.39 181.833c.149.189 3.322 7.553 2.945 14.533h11.174c.213-3.816 2.612-9.276 2.612-9.276s-4.92 2.01-8.246 7.75c0 0-2.518-10.356-8.485-13.007m-17.516 3.301c-.133.259-2.823 4.96-3.531 10.456l-10.653 1.103c-.726-4.886-2.292-7.606-2.292-7.606s4.473 1.312 6.86 5.149c0 0 2.768-5.903 9.616-9.102"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      d="M200 200H0c.243-2.544 1.702-4.5 3.466-4.5h193.068c1.764 0 3.223 1.956 3.466 4.5z"
      fill="#D6EEFF"
    />
    <path
      clipRule="evenodd"
      d="M148.545 199.437c0 .311-21.925.563-48.97.563-27.046 0-48.971-.252-48.971-.563 0-.31 21.925-.562 48.97-.562 27.046 0 48.971.252 48.971.562"
      fill="#AFB4C8"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M147.141 144.895s7.392 4.454 11.859 5.234l-12.591-13.815-4.105 4.181 4.837 4.4z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M92.63 130.791l23.325 33.224a4.962 4.962 0 007.246.955l23.381-19.566-4.326-4.884-21.084 14.491-18.719-28.543-9.822 4.323z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M54.549 184.776s-7.88-2.299-12.396-1.388l15.681 9.677 1.775-5.218-5.06-3.071z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M54.726 184.47l4.884 3.377 14.787-27.149 12.7-13.394-9.137-4.796-8.444 9.84a25.776 25.776 0 00-4.219 6.841L54.726 184.47zm51.781-78.411c3.293.555 10.989 18.578 10.989 18.578l-3.363 1.898-8.784-12.982-8.19-1.021-1.201-8.461s6.548 1.313 10.549 1.988"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M86.855 130.555l-15.643 16.971 10.493 9.613 22.435-23.589-4.508-7.082-12.778 4.087z"
      fill="#20262D"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M97.616 115.565l-13.324-.487.891-12.293 11.816.922.617 11.858z"
      fill="#DD036C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M67.185 89.074s-2.911 6.695 3.315 6.727z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M90.3 129.512l16.738 26.987 11.931-8.076-14.459-24.871-14.21 5.96z"
      fill="#364150"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M93.422 104.502c3.184 1.867 5.063 6.285 5.063 6.285l6.025 12.765-18.13 7.603-5.523-9.528s-2.959-3.848-2.928-9.022c.023-3.615 1.817-5.947 1.996-6.17l.002-.002a10.02 10.02 0 012.203-1.81l2.399-1.733s3.475-1.566 8.893 1.612"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M97.735 128.315c-2.464 3.238-23.127 2.334-23.127 2.334l-.01-4.321 17.363-2.692-2.456-7.294 8.67-1.156s2.554 9.193-.44 13.129M83.85 92.686c.114-1.37 3.614-3.924 5.255-1.325 2.117 3.352-4.29 6.548-4.29 6.548l1.641 4.637h.455s-1.248 5.676-5.554 6.138c-3.04.327-1.892-1.671-1.892-1.671l.676-.805-1.199-4.809s-6.051 2.018-7.505 1.67c0 0-2.48-5.777-2.614-10.279l3.926-5.84 8.328-1.436 2.773 7.172z"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M86.652 90.296s3.568-2.605-2.25-6.238c-5.82-3.634-9.322-.122-9.322-.122s-2.378-4.587-5.593-3.77c-4.579 1.163-3.52 8.423-3.52 8.423s-2.105-3.567-3.282-2.689c-1.177.879.811 13.975 17.496 3.19 0 0-.688 3.92 3.67 3.595 0 0 .353-1.688 2.801-2.389"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M82.086 82.851L81.896 80l-1.282.085.255 3.829 2.27.465 1.883-3.202-1.108-.652-1.418 2.41-.41-.084z"
      fill="#001F68"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M78.943 101.399l3.842-1.883-3.36 3.737-.482-1.854zm10.562 14.943l8.67-1.156.491 2.198-8.95-.415-.21-.627zm20.001 38.487l7.996-5.413 1.467 2.237-9.463 3.176zm-36.927-6.05l7.021 6.432-1.37 1.445-5.651-7.877z"
      fill="#000"
      fillRule="evenodd"
      opacity={0.401}
    />
    <path
      clipRule="evenodd"
      d="M69.656 96.57l-.5 3.302 1.477-.338-.977-2.965z"
      fill="#F49E7C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M71.256 99.961l.05.383.049.382h.003l.007-.001a.295.295 0 01.02-.003l.063-.012a2.257 2.257 0 00.824-.34c.22-.152.441-.375.572-.693.132-.322.157-.705.044-1.151l-.748.188c.08.314.05.526-.01.67a.79.79 0 01-.295.35 1.437 1.437 0 01-.573.226l-.007.002h.001z"
      fill="#0D1A88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M89.505 116.342l.211.627-2.04-.352 1.83-.275zm8.671-1.156l.49 2.198 2.231.053-1.126-2.451-1.595.2z"
      fill="#DD036C"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M70.633 96.221a.748.748 0 101.495.02.748.748 0 00-1.495-.02"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.587 126.691l-.882-.976s-.651-.641-1.436-1.25c-.785-.609-2.094-.943-2.828-2.679-.733-1.735-1.087.335-.765 1.187.268.711 1.419 1.611 1.522 2.262-.36.108-.68.099-.68.099l-6.033-.738a.404.404 0 00-.446.287l-.062.219a.403.403 0 00.313.509c1.266.231 5.064.824 5.044.889l.016.154-6.333-.125a.405.405 0 00-.42.335l-.053.314a.4.4 0 00.347.468c1.406.169 6.22.349 6.201.418l-.002.181-5.4.372a.404.404 0 00-.422.364l-.024.255a.401.401 0 00.365.44l5.256-.197.047.201-4 .727a.406.406 0 00-.379.381l-.005.124a.404.404 0 00.373.424c.752.058 2.502-.342 4.184-.352 1.307-.008 2.248.285 3.892.097.696-.079 1.2-.263 1.699-.422"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M139.426 142.394l4.732 4.98 2.983-2.479-4.837-4.399-2.878 1.898zm-84.877 42.382l5.06 3.071 1.96-3.635-5.523-2.899-1.497 3.463z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M79.125 128.497h-.15v.939h.15a.12.12 0 00.12-.12v-.699a.12.12 0 00-.12-.12"
      fill="#7E7E8E"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.77 130.066c.037.099.156.44.178.89.008.189.174.385.385.385h1.43c.212 0 .376-.196.386-.385.022-.45.14-.791.179-.89a.76.76 0 01-.186.022h-2.188a.753.753 0 01-.185-.022m2.559-3.417a2.99 2.99 0 01-.179-.89c-.008-.189-.174-.386-.385-.386h-1.43c-.213 0-.376.197-.386.386-.022.45-.14.79-.179.89a.762.762 0 01.185-.022h2.189c.064 0 .125.007.185.022"
      fill="#BABAC3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.12 126.965v2.785a.836.836 0 00.834.834h2.188a.836.836 0 00.833-.834v-2.785a.836.836 0 00-.833-.834h-2.188a.836.836 0 00-.833.834"
      fill="#9191A0"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M75.951 130.376h2.194c.358 0 .65-.292.65-.65v-2.737a.652.652 0 00-.65-.65h-2.194a.652.652 0 00-.65.65v2.737c0 .358.293.65.65.65"
      fill="#030305"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M76.11 130.066h1.878a.538.538 0 00.536-.537v-2.344a.538.538 0 00-.536-.536h-1.879a.538.538 0 00-.536.536v2.344c0 .296.241.537.537.537"
      fill="#CACAD4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M77.747 127.279a.214.214 0 01.316.29l-.857.933a.215.215 0 01-.308.008l-.598-.585a.214.214 0 11.3-.306l.44.431.707-.771z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M77.134 128.161a.215.215 0 00-.282.111l-.517 1.192a.215.215 0 00.393.171l.517-1.192a.214.214 0 00-.111-.282z"
      fill="#FC1C88"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M117.376 132.047s1.131.151 1.583-1.034c0 0 .864-.385.896-1.398 0 0 .767-.63.318-1.566-.421-.878-1.779-2.644-2.93-4.109v-.001l-.226-.288-1.266.705-2.034 1.132-.207.689s-.23 1.355-.381 2.407c-.043.305-.081.582-.104.796-.045.421.032.764.167 1.039v.002c.362.736 1.145.994 1.145.994s.82 1.237 1.589 1.536c.653.255 1.399-.485 1.45-.904"
      fill="#FCBDA4"
      fillRule="evenodd"
    />
  </React.Fragment>
);

// ------------------------------
// Report
// ------------------------------

export const MediumReport = createIllustration(
  describeWithOptions(
    'MediumReport',
    'Illustration of a person sitting in a chair, working on their laptop and happily looking up on the frames of stylised graphic charts and user interface above them.'
  ),
  <React.Fragment>
    <path
      clipRule="evenodd"
      d="M178.451 193.502c-.058.079-1.807 2.477-2.027 4.685h-3.075c1.452-2.963 5.022-4.648 5.102-4.685M158.357 198.187h3.408c.02-2.352 1.277-5.414 1.277-5.414s-3.74 2.934-4.685 5.414"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M169.425 156.916c.589-1.755 3.818-1.458 3.818-6.353.001-7.371-10.198-6.53-10.8-12.083-.601-5.554 5.953-5.421 6.156-10.105.203-4.684-5.237-9.939-11.199-9.939s-3.1 5.369-7.912 8.704c-4.811 3.335-9.374-3.259-12.094 1.985-3.746 7.224 5.834 15.9 4.888 21.438-.945 5.538-6.561 4.228-6.732 10.313-.172 6.085 2.613 5.035 1.844 10.252-.484 3.289-2.815 3.264-3.086 9.749-.229 5.492 20.05 13.335 33.375 2.161 13.325-11.174-.507-19.421 1.742-26.122Z"
      fill="#C3E4FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M153.463 142.799v55.18h2.291v-55.18h-2.291ZM144.406 175.323l4.875 4.957 1.371-1.394-4.876-4.957-1.37 1.394ZM145.447 156.166l5.038 4.957 1.417-1.394-5.039-4.957-1.416 1.394ZM163.314 145.193l-4.957 4.958 1.394 1.393 4.957-4.957-1.394-1.394ZM158.044 175.639c0 8.652 3.573 16.51 11.661 16.51 8.089 0 11.661-7.858 11.661-16.51 0-10.15-6.112-20.242-11.661-20.242-5.548 0-11.661 10.092-11.661 20.242"
      fill="#E8F6FF"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M168.456 171.742v26.237h2.603v-26.237h-2.603ZM162.001 173.157l4.286 4.832 1.232-1.102-4.286-4.832-1.232 1.102ZM176.281 179.447l-4.285 4.832 1.232 1.102 4.286-4.832-1.233-1.102ZM176.281 172.263l-4.285 4.748 1.232 1.082 4.286-4.747-1.233-1.083Z"
      fill="#D6EEFF"
      fillRule="evenodd"
    />
    <path
      d="M93.91 199.853h93.807c-.114-1.118-.798-1.978-1.626-1.978H95.536c-.828 0-1.512.86-1.626 1.978Z"
      fill="#D6EEFF"
    />
    <path
      clipRule="evenodd"
      d="M46.972 160.323a.439.439 0 0 0-.425-.339h-.004l-16.9-.065a.503.503 0 0 0-.491.389l-8.074 39.344a.288.288 0 0 0 .215.338.286.286 0 0 0 .343-.207l8.406-38.856 16.154-.062 8.355 38.918a.287.287 0 0 0 .558-.131l-8.137-39.329Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M41.038 160.323a.439.439 0 0 0-.425-.339h-.004l-16.9-.065h-.001a.502.502 0 0 0-.49.389l-8.074 39.344a.288.288 0 0 0 .214.338.286.286 0 0 0 .343-.207l8.406-38.856 16.155-.062 8.354 38.918a.287.287 0 0 0 .558-.131l-8.136-39.329Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M19.425 138.599c.845 4.185 5.605 17.252 8.174 18.722 2.568 1.469 17.566 1.183 19.326 1.33 1.759.147 3.665 1.175 3.372 3.084-.293 1.909-1.026 1.321-6.158 1.321-5.132 0-17.154.086-17.154.086s-6.226.386-8.788-5.848c-2.347-5.71-4.424-16.246-4.717-18.155-.293-1.909-.081-4.251 1.371-4.726 1.1-.36 3.729 0 4.574 4.186Z"
      fill="#FFB027"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M130.938 82.607H26.431a2.406 2.406 0 0 1-2.406-2.406V6.415a2.406 2.406 0 0 1 2.406-2.407h104.507a2.406 2.406 0 0 1 2.406 2.407v73.786a2.406 2.406 0 0 1-2.406 2.406Z"
      fill="#F2F3F4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M126.513 78.911H22.007a2.406 2.406 0 0 1-2.407-2.406V2.719A2.406 2.406 0 0 1 22.008.312h104.506a2.407 2.407 0 0 1 2.407 2.407v73.786a2.407 2.407 0 0 1-2.407 2.406Z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      d="M126.513 0H22.007a2.719 2.719 0 0 0-2.719 2.719v73.786a2.719 2.719 0 0 0 2.719 2.719h104.506a2.719 2.719 0 0 0 2.719-2.719V2.719A2.719 2.719 0 0 0 126.513 0ZM22.007.625h104.506c1.157 0 2.094.937 2.094 2.094v73.786a2.094 2.094 0 0 1-2.094 2.094H22.007a2.094 2.094 0 0 1-2.094-2.094V2.719c0-1.157.937-2.094 2.094-2.094Z"
      fill="#E4E7EA"
    />
    <path
      clipRule="evenodd"
      d="M83.545 38.737H39.88a7.005 7.005 0 0 1 0-14.01h43.665a7.005 7.005 0 1 1 0 14.01Z"
      fill="#FFB027"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M108.241 38.544a7.005 7.005 0 1 1 0-14.01 7.005 7.005 0 0 1 0 14.01Z"
      fill="#C7D2F2"
      fillRule="evenodd"
    />
    <path
      d="M122.297 5.72a.468.468 0 0 1 .679.646l-.016.017-4.373 4.373a.47.47 0 0 1-.679-.645l.016-.017 4.373-4.373Z"
      fill="#E4E7EA"
    />
    <path
      d="M117.924 5.72a.47.47 0 0 1 .646-.016l.017.017 4.373 4.373a.467.467 0 0 1 .008.653.47.47 0 0 1-.653.026l-.018-.017-4.372-4.373a.469.469 0 0 1 0-.662h-.001Z"
      fill="#E4E7EA"
    />
    <path
      d="M95.004 47.632a1.874 1.874 0 0 1 .035 3.748h-60.29a1.874 1.874 0 0 1-.035-3.748h60.29Zm-25.84 11.14a1.874 1.874 0 0 1 .034 3.748H34.75a1.874 1.874 0 0 1-.035-3.747H69.164Z"
      fill="#C7D2F2"
    />
    <path
      d="M176.604 60.282H95.916a6.663 6.663 0 0 0-6.664 6.663v55.805a6.664 6.664 0 0 0 6.664 6.664h80.688a6.664 6.664 0 0 0 6.663-6.664V66.945a6.663 6.663 0 0 0-6.663-6.663Z"
      fill="#F2F3F4"
    />
    <path
      d="M171.919 56.846H91.231a6.663 6.663 0 0 0-6.663 6.664v55.805a6.663 6.663 0 0 0 6.663 6.663h80.688a6.663 6.663 0 0 0 6.663-6.663V63.51a6.663 6.663 0 0 0-6.663-6.664Z"
      fill="#fff"
    />
    <path
      d="M171.919 56.534H91.231a6.976 6.976 0 0 0-6.976 6.976v55.805a6.975 6.975 0 0 0 6.976 6.975h80.688a6.975 6.975 0 0 0 6.976-6.975V63.51a6.976 6.976 0 0 0-6.976-6.976Zm-80.688.625h80.688a6.35 6.35 0 0 1 6.351 6.35v55.806a6.351 6.351 0 0 1-6.351 6.351H91.231a6.351 6.351 0 0 1-6.351-6.351V63.51a6.35 6.35 0 0 1 6.35-6.351Z"
      fill="#E4E7EA"
    />
    <path
      d="M154.392 76.947c5.346-1.313 10.306 4.671 15.069 17.686a.627.627 0 0 1-1.047.638.627.627 0 0 1-.126-.209c-4.556-12.449-9.152-17.994-13.598-16.902-2.445.6-4.474 2.145-6.353 4.664l-.129.176c-1.328 1.81-2.314 3.613-4.218 7.508l-.648 1.329c-1.941 3.957-2.95 5.771-4.397 7.692-2.069 2.747-4.371 4.452-7.189 5.077-2.011.447-3.65-.364-5.034-2.23l-.042-.057c-1.005-1.377-1.727-2.943-2.998-6.207l-.393-1.013c-1.214-3.11-1.925-4.659-2.872-6.016-1.195-1.712-2.483-2.516-4.061-2.42-5.803.35-12.054 6.89-18.635 19.702a.622.622 0 0 1-.84.268.625.625 0 0 1-.272-.839c6.767-13.173 13.285-19.993 19.672-20.379 2.05-.124 3.705.895 5.118 2.893l.042.06c1.002 1.436 1.731 3.006 2.934 6.079l.545 1.399c1.172 3 1.855 4.473 2.742 5.698l.027.038c1.124 1.54 2.307 2.135 3.796 1.805 2.495-.555 4.558-2.082 6.462-4.61l.132-.176c1.332-1.797 2.321-3.597 4.207-7.45l.647-1.326c1.937-3.957 2.941-5.777 4.357-7.686l.046-.061c2.038-2.734 4.297-4.454 7.056-5.131Z"
      fill="#FFB027"
    />
    <path
      d="M165.616 78.227a.63.63 0 0 1 .982-.34.622.622 0 0 1 .241.413.644.644 0 0 1-.014.243c-3.874 14.809-8.852 21.761-15.117 20.562-2.713-.519-4.609-.423-6.017.199-1.085.478-1.843 1.194-2.907 2.611l-.123.165-.635.867c-.273.371-.492.661-.717.944-.937 1.18-1.861 2.085-3.017 2.867-1.399.945-3.074 1.648-5.137 2.106-1.901.422-3.531.207-5.037-.577-1.121-.584-2.011-1.338-3.408-2.765l-.654-.674c-1.408-1.451-2.224-2.179-3.248-2.793-1.303-.78-2.69-1.138-4.337-1.038-5.948.359-12.25 3.296-18.906 8.833a.616.616 0 0 1-.46.148.63.63 0 0 1-.427-.223.618.618 0 0 1-.141-.461.628.628 0 0 1 .229-.424c6.844-5.695 13.387-8.743 19.629-9.12 1.905-.115 3.54.307 5.054 1.214l.102.061c1.063.652 1.912 1.405 3.271 2.799l.655.675.121.124c1.312 1.341 2.124 2.029 3.097 2.536 1.246.648 2.576.824 4.189.466 1.913-.425 3.442-1.067 4.708-1.922 1.04-.703 1.876-1.521 2.739-2.609l.113-.144c.164-.211.326-.424.484-.64l.708-.965.045-.061c1.236-1.666 2.142-2.542 3.506-3.143 1.669-.737 3.814-.846 6.755-.283 5.335 1.02 9.954-5.43 13.674-19.65Z"
      fill="#009BA0"
    />
    <path
      d="M156.042 80.064a2.655 2.655 0 1 0 0-5.31 2.655 2.655 0 0 0 0 5.31Z"
      fill="#FC1C88"
    />
    <path d="M93.938 113.38h73.817v.208H93.938v-.208Z" fill="#C7D2F2" />
    <path
      clipRule="evenodd"
      d="M37.924 108.432c1.447.825 3.655 2.541 4.968 6.55 1.104 3.37 3.63 8.235 3.71 8.724 1.306.489 6.523 3.095 6.523 3.095s-3.596 5.811-3.892 5.811c-.296 0-2.05-.091-3.749-.225-5.545-.436-5.83-4.24-6.105-5.792-.89-5.022-1.04-17.624-1.455-18.163"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M29.354 100.615s1.202 5.972.394 6.593c-.404.309-2.13.766-2.13.766s4.252 3.389 6.851 3.477c2.6.087 4.337-1.497 4.049-2.071-.43-.859-3.476-1.626-3.59-2.391-.13-.872-.073-4.689-.073-4.689l-5.501-1.685Z"
      fill="#CA8F67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M21.285 110.552c-.123 1.1-1.327 14.78.3 16.83 1.947 2.455-.916 10.319-2.155 12.321-2.156 3.482-4.586 9.741 3.326 4.63 7.184-4.64 16.805-5.144 18.686-5.7.64-.189.2-.781.16-1.189-.483-4.746.686-14.651.695-17.993.006-2.148-2.376-9.873-4.25-10.98-.373-.22-2.215-1.006-2.215-.699 0 1.508-.12 3.647-.837 3.647-1.824 0-6.544-3.315-7.275-3.647-1.676.34-6.294 1.524-6.435 2.78Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M40.08 112.865c1.007 1.94 2.09 3.984 2.188 6.186.125 2.779-.192 5.954-.29 8.739a58.52 58.52 0 0 0-.056 2.183c.001.042-.071.046-.07 0-.07-3.388.352-7.52.198-10.912-.098-2.169-1.165-4.268-2.041-6.243-.015-.028.055.016.071.047"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m49.832 128.431-12.456 1.055c-.212.018-.88.297-.903.509 0 0-.098.547.477.547h12.882v-2.111Z"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M66.808 130.542h-19.5l5.38-14.305c.327-.808 1.018-1.615 2.11-1.615l16.303.012c1.752-.013 1.972.638 1.595 1.664-1.085 2.954-3.877 11.224-4.836 13.541a1.138 1.138 0 0 1-1.052.703"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M71.014 114.526c-4.501-.011-10.747-.02-15.26-.031-1.573-.098-2.55.168-3.2 1.724a1106.889 1106.889 0 0 0-4.546 12.31l-9.998.904c.95-.077 10.053-.733 10.08-.817 1.6-3.996 3.283-8.686 4.882-12.669.654-1.208 1.559-1.246 2.782-1.197l3.391-.002c2.219.011 8.032-.021 10.174-.005.77.09 3.199-.338 3.41.65.04.938-.535 1.876-.809 2.774-.247.812-1.117 3.206-1.117 3.206-.889 2.511-1.889 5.53-2.834 7.995-.356 1.126-.828 1.137-1.886 1.11-.535.004-1.928.063-2.479.068-.066.001-.132.046-.064.048.974-.013 2.438.039 3.398.008.642-.036.996-.63 1.168-1.18 1.022-2.639 1.942-5.316 2.88-7.985.364-1.103 1.287-3.76 1.697-4.799.657-1.666-.116-2.163-1.669-2.112"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m35.092 129.638-.062.006.062-.005v-.001Z"
      fill="#000"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M57.185 130.504h3.472c1.23.022.587-2.498 1.932-2.253 1.148.209 1.096.883.977 2.243.233-.291.674-.387.826-.288.216.141-.026.183-.391.769-.422.677-1.623 1.31-3.053 1.431-.43.036-2.904.414-2.904.414l-.859-2.316Zm-20.251-1.25s.965-.688 1.792-.591c1.104.129 1.192-.369 1.474.065.062.096-.133.402-.644.516-.69.153-.4.579-.4.579s2.396.573 2.733.633c.186.033.237.564-1.17.982-.735.218-1.784.224-3.02.265-.345.012-4.3 1.221-4.3 1.221l-.244-1.973-.124-2.051 3.903.354Z"
      fill="#CA8F67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M49.273 132.614s9.933.402 10.552.291c.619-.111-.635-2.378-.635-2.378h-8.975l-.942 2.087Z"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M60.847 122.816h-.001c-.444 0-.64-.187-.716-.298a.184.184 0 0 1 .047-.254.189.189 0 0 1 .202-.003.18.18 0 0 1 .051.05c.062.089.213.14.416.14h.001c.311 0 .529-.117.63-.187a.189.189 0 0 1 .202-.003.183.183 0 0 1 .004.304 1.488 1.488 0 0 1-.836.251"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M59.592 123.106c-.247.646-.968 1.169-1.61 1.169-.64 0-.96-.523-.713-1.169.247-.645.968-1.169 1.61-1.169.64 0 .96.524.713 1.169Zm4.567 0c-.247.646-.967 1.169-1.609 1.169-.641 0-.961-.523-.714-1.169.248-.645.968-1.169 1.61-1.169.641 0 .96.524.713 1.169"
      fill="#FF00A4"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M59.989 121.559a.496.496 0 0 1-.424.307c-.169 0-.253-.137-.188-.307.065-.17.255-.308.423-.308.17 0 .254.138.189.308Zm3.222 0a.496.496 0 0 1-.424.307c-.169 0-.253-.137-.188-.307.066-.17.255-.308.424-.308.169 0 .253.138.188.308Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M27.62 120.227c-.885 2.332-5.794 7.541-5.794 7.541s11.484 1.193 13.181 1.193c.04.597-.46 5.129-.46 5.129-4.998.708-20.865 2.758-22.122-1.44-2.618-8.746 7.655-20.681 8.974-22.295 1.847-2.261 7.402 6.752 6.22 9.872"
      fill="#0B096F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M34.98 128.905c-4.41-.21-8.428-.942-12.848-1.331 1.557-1.669 3.07-3.387 4.369-5.265.445-.663.85-1.321 1.114-2.079.009-.024.072-.221.048-.23-1.032 2.106-2.727 4.125-4.332 5.877a61.07 61.07 0 0 1-1.648 1.718c-.092.087-.22.243.101.264 3.389.226 6.783.649 10.164.965 1.133.083 1.727.136 2.867.14.183 0 .234-.061.165-.059Zm-.289 3.602c-.054 0-.456 1.584-.58 1.601-4.179.577-8.68 1.178-12.915 1.047-.08-.008-.005.068.082.077 3.11.339 9.868-.381 10.884-.578 1.895-.367 2.057-.339 2.139-.467.296-1.12.426-1.68.39-1.68Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.518 88.432s4.375 2.722 3.609 8.086c-.485 3.395 1.06 4.225 0 8.157-.485 1.798-1.46 3.513-3.442 3.902-1.497.295-5.146-.388-7.783-2.104-1.5-.977-2.234-2.347-2.844-4.289-1.717-.144-3.71-2.858-2.217-3.954.35-.256.703-.351 1.076-.297-.575-2.592-.48-3.58-.48-4.745 0-1.616-1.952-3.555 1.74-3.97 3.694-.416 9.565-1.821 10.34-.786Z"
      fill="#CA8F67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M31.26 100.676c.335-.72-.035-2.297-.587-3.537-.267-.602-.827-4.972 1.291-4.783 2.174.193 3.098.514 5.17.473 1.311-.026 3.64-1.105 3.675-1.474.526.303 1.907.575 2.363 3.047.88-.955.792-2.284.57-3.537-.332-1.88-2.48-2.034-2.727-2.065.282-.708-.36-2.332-1.135-3.08-.547-.528-2.114-2.258-4.485-1.983-1.306.151-1.736 1.613-1.736 1.613-.527-.339-2.53-.49-3.853.001-2.21.822-.58 2.217-.334 2.494-.599.154-2.767 1.261-3.657 3.02-1.154 2.282-.381 4.512.703 5.945 1.085 1.433 1.665.924 2.857 1.96.69.98 1.574 2.574 1.885 1.906Z"
      fill="#001386"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M27.366 99.518c.484-.608 1.325-.274 1.7.281.172.254.238.728.146.832-.021.025-.08-.164-.119-.24-.358-.691-.71-1.024-1.657-.769-.058.015-.107-.056-.07-.103"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M28.968 100.208c-.553.015-.318.962-.518.703-.101-.397.045-.916.508-.988.21-.037.223.306.01.285Zm6.46 8.109c-.976-.198-1.623-.601-2.496-1.042-.052-.029-.987-.641-1.018-.727-.04-.11.048-.044.114 0 .77.516 2.785 1.279 4.007 1.622.053.009.385.146.214.179a2.667 2.667 0 0 1-.821-.032Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m40.727 102.862-3.863-.155c-.34-.014-.64.582-.054 1.362.829 1.106 2.977 1.49 3.85.155.446-.68.42-1.348.067-1.362"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M39.568 99.71c.42.394 1.476 1.972.525 2.201-.196.047-1.094.07-.962-.125.106-.156.77-.064.865-.36.126-.388-.332-1.149-.617-1.67-.049-.09.123-.123.19-.045Zm-2.023-.904c.023.798-1.005 1.252-1.833.81-.426-.227-.633-.547-.52-.67.073-.079.261.049.324.09.834.557 1.54.131 1.772-.316.09-.175.25-.17.257.086Zm4.316-.327c-.084.32-.218.476-.382.582-.478.31-1.212-.063-1.34-.38-.095-.235.055-.233.224-.115.27.189.533.238.71.214.34-.046.517-.376.646-.51.07-.072.208-.04.142.21Zm-4.374-2.061c.325.355.223.924-.215.787-1.194-.707-2.295-.94-3.41-.073-.4.312-.585.026-.445-.31.1-.238.5-.667.823-.82 1.06-.503 2.537-.36 3.247.416Zm4.59-.523c.186.157.299.456-.018.52-.113.022-1.268-.42-2.102.465-.187.199-.583.129-.525-.22.149-.892 1.71-1.56 2.646-.765Z"
      fill="#090E2B"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M44.235 183.501s-1.068 7.543-1.504 10.766c-.44 3.25 7.38.086 7.38.086s-1.41-2.009-1.431-2.559c-.021-.55 2.386-6.992 2.386-6.992l-6.83-1.301Z"
      fill="#CA8F67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M59.896 141.907c3.838 1.754 7.717 6.183 4.326 14.486-3.39 8.302-11.368 28.396-12.622 29.3-1.254.904-7.868-.891-7.868-.891s.724-8.439 2.16-16.737c1.053-6.076 3.272-10.507 3.272-10.507s-17.847 2.547-22.277-.442c-5.816-3.923-1.51-14.494 1.832-15.803 4.297-1.683 23.87-2.745 31.177.594Z"
      fill="#0078C2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M59.695 197.874c-.56-1.737-4.627-2.884-7.563-3.752-.989-.293-2.37-1.737-3.01-1.719-.934.025-.02 1.967-3.143 1.798-.827-.045-.886-.915-2.683-1.113-.292-.032-.739-.089-1.124.605-.215.387-1.095 3.88-.231 5.304 6.047.157 12.268.002 17.641-.048.525-.005.256-.631.113-1.075"
      fill="#FF0057"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M69.676 184.802s1.1 5.675 1.835 6.599c.736.923 4.553 1.961 4.725 2.532.17.57-8.137 1.905-8.137 1.905l-5.083-10.547 6.66-.489Z"
      fill="#CA8F67"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M83.745 197.561c-.56-1.736-4.627-2.883-7.563-3.752-.988-.292-2.37-1.736-3.01-1.719-.934.026-.019 1.968-3.143 1.799-.827-.045-.886-.916-2.683-1.114-.292-.032-.738-.088-1.124.605-.215.387-1.095 3.881-.23 5.305 6.047.157 12.267.002 17.64-.048.525-.005.257-.631.113-1.076"
      fill="#FF0057"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M76.728 195.05c.384-.773.552-.907.388-1.029-.391-.291-2.38.608-2.536 1.143-.117.401 1.207-.759 2.264-.933-.433.396-.837 1.609-.41 1.367 2.077-1.178 2.404-.904 2.407-.948.012-.208-.774-.377-2.113.4"
      fill="#FFB201"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M20.238 149.924c1.246 6.45 6.993 8.768 11.98 8.575 7.617-.294 15.382-3.677 18.007-4.808-.23 1.664 1.006 11.124 3.07 15.502 2.063 4.378 8.785 17.548 8.785 17.548s7.583.045 7.908-1.796c.213-1.211-6.907-35.037-9.262-40.893-1.352-3.364-5.73-4.815-14.733-5.58-9.043-.769-22.225.648-22.225.648s-4.776 4.354-3.53 10.804Z"
      fill="#0091EA"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M52.678 195.467c.384-.773.552-.908.388-1.03-.392-.291-2.38.608-2.537 1.143-.117.401 1.208-.759 2.265-.932-.433.395-.837 1.609-.41 1.367 2.077-1.178 2.404-.905 2.407-.949.012-.208-.774-.377-2.113.401"
      fill="#FFB201"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m58.417 199.627-14.556.257c-.974.039-2.43-.296-2.572-1.105-.105-.605.129-1.921.178-2.009.339-.61 3.228-.095 4.07 1.965 5.311.398 14.356.009 14.356.009s.136.8-1.476.883Zm24.04-.375-14.557.256c-.974.039-2.431-.296-2.572-1.105-.105-.604.129-1.92.177-2.008.34-.61 3.23-.095 4.07 1.965 5.312.398 14.357.009 14.357.009s.136.8-1.476.883"
      fill="#090E2B"
      fillRule="evenodd"
    />
  </React.Fragment>
);
